<template>
  <div class="task-dialog-shell">
    <!-- Floating close button -->
    <button
      type="button"
      class="dialog-close-btn"
      @click="$emit('close')"
      aria-label="Close"
    >
      <i class="fa fa-xmark"></i>
    </button>

    <div class="page-shell">
      <!-- LEFT SIDE -->
      <main class="task-main">
        <!-- Header -->
        <header class="page-header">
          <div class="breadcrumb">
            <span>HR Task Board</span>
            <span class="crumb-sep">/</span>
            <span>Task</span>
            <template v-if="task.task_number">
              <span class="crumb-sep">/</span>
              <span class="crumb-number" :title="'Topshiriq raqami: ' + task.task_number">
                <i class="fa-solid fa-hashtag"></i>{{ task.task_number }}
              </span>
            </template>
          </div>
          <div class="task-type-pill">
            <label class="popup">
              <input type="checkbox" />
              <div class="burger" tabindex="0">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <nav class="popup-window">
                <legend>Actions</legend>
                <ul>
                  <li>
                    <button>
                      <svg stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor"
                        fill="none" viewBox="0 0 24 24" height="14" width="14" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle r="4" cy="7" cx="9"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                      <span>Colloborators</span>
                    </button>
                  </li>
                  <li>
                    <button v-if="(task.column_id == 2 || task.column_id == 1) && !task.members.some(m => m.user_id === userId && (m.process === 'Malumot' || m.process === 'Test'))" 
                      @click="redirectToEmployee(task.id)">
                      <svg stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor"
                        fill="none" viewBox="0 0 24 24" height="14" width="14" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                      </svg>
                      <span>Redirect task</span>
                    </button>
                  </li>
                  <li>
                    <button v-if="canMoveBack()" @click="updateTaskColumn(task.id, task.column_id - 1)">
                      <i class="fa-solid fa-angles-left hover-color" style="color: cornflowerblue;"></i>
                      <span>Back</span>
                    </button>
                  </li>
                  <li>
                    <button v-if="canMoveNext()" @click="updateTaskColumn(task.id, task.column_id + 1)">
                      <i class="fa-solid fa-angles-right hover-color" style="color: cornflowerblue;"></i>
                      <span>Next</span>
                    </button>
                  </li>
                  <li>
                    <button v-if="task.column_id == 4 && task.user_id == userId" @click="acceptTask()">
                      <i class="fa-solid fa-check-double hover-color" style="color: #28a745;"></i>
                      <span>Qabul qilish</span>
                    </button>
                  </li>
                  <hr />
                  <li>
                    <button @click="copyTask()">
                      <svg stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor"
                        fill="none" viewBox="0 0 24 24" height="14" width="14" xmlns="http://www.w3.org/2000/svg">
                        <rect ry="2" rx="2" height="13" width="13" y="9" x="9"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                      </svg>
                      <span>Clone</span>
                    </button>
                  </li>
                  <li>
                    <button v-if="task.column_id == 1 && task.user_id == userId" @click="editTask(task)">
                      <svg stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor"
                        fill="none" viewBox="0 0 24 24" height="14" width="14" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="16 3 21 8 8 21 3 21 3 16 16 3"></polygon>
                      </svg>
                      <span>Edit</span>
                    </button>
                  </li>
                  <hr />
                  <li>
                    <button v-if="task.column_id == 1 && task.user_id == userId" @click="deleteTask(task.id)">
                      <svg stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor"
                        fill="none" viewBox="0 0 24 24" height="14" width="14" xmlns="http://www.w3.org/2000/svg">
                        <line y2="18" x2="6" y1="6" x1="18"></line>
                        <line y2="18" x2="18" y1="6" x1="6"></line>
                      </svg>
                      <span>Delete</span>
                    </button>
                  </li>
                  <li>
                    <button @click="getHelp()" v-if="(task.column_id == 2 || task.column_id == 1) && task.members.some(m => m.user_id === userId && m.process === 'Ijro')">
                      <i class="fa-regular fa-square-plus hover-color" style="color: cornflowerblue;"></i>
                      <span>Yordam</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </label>
            Task
          </div>
        </header>

        <!-- TITLE -->
        <section>
          <div class="task-title-row section-card">
            <div>
              <h1>{{ task.text }}</h1>
              <div class="hint">
                Created by {{ task.user_fullname || 'Unknown' }} ·
                {{ startDate }}
              </div>
            </div>

            <div class="title-actions">
              <button class="icon-btn">
                <span class="material-symbols-outlined">smart_toy</span>
                
              </button>

              <button class="icon-btn icon-btn-ghost">
                <span class="material-symbols-outlined">more_horiz</span>
              </button>
            </div>
          </div>

          <div class="section-card">
            <div class="section-header mx-2">
              <h2>Topshiriq</h2>
              <span class="section-hint">
                Add or update task details
              </span>
            </div>

            <div class="description-editor description-editor--prime">
              <Editor
                v-model="localDescription"
                editor-style="min-height: 80px"
                readonly
              />
            </div>

            <!-- Attachments -->
            <details v-if="task.file_path || (task.files && task.files.length > 0)" class="task-attachments-section mt-3">
              <summary class="attachment-section-title">
                <div class="d-flex align-items-center w-100">
                  <i class="fa-solid fa-paperclip me-2 text-primary"></i> 
                  <span>Ilova qilingan fayllar <span class="badge bg-primary ms-1" style="font-size:10px">{{ (task.files ? task.files.length : 0) + (task.file_path ? 1 : 0) }}</span></span>
                  <i class="fa-solid fa-chevron-down ms-auto summary-chevron"></i>
                </div>
              </summary>
              <div class="task-files-grid mt-3">
                <!-- Single legacy file -->
                <a v-if="task.file_path" :href="getFileUrl(task.file_path)" target="_blank" class="task-file-chip-modern">
                  <div class="file-icon-bg">
                    <i class="fa-solid fa-file-lines text-primary"></i>
                  </div>
                  <div class="file-chip-info">
                    <span class="file-chip-name text-truncate" :title="task.file_name">{{ task.file_name || 'Biriktirilgan fayl' }}</span>
                    <span class="file-chip-meta">Yuklab olish</span>
                  </div>
                  <div class="download-btn"><i class="fa-solid fa-download"></i></div>
                </a>
                
                <!-- Multiple files array -->
                <a v-for="(file, idx) in (task.files || [])" :key="'f-'+idx" :href="getFileUrl(typeof file === 'string' ? file : (file.path || file.file_path || file.url))" target="_blank" class="task-file-chip-modern">
                  <div class="file-icon-bg">
                    <i class="fa-solid fa-file-lines text-primary"></i>
                  </div>
                  <div class="file-chip-info">
                    <span class="file-chip-name text-truncate" :title="typeof file === 'string' ? file.split('/').pop() : (file.name || file.file_name || file.original_name)">{{ typeof file === 'string' ? file.split('/').pop() : (file.name || file.file_name || file.original_name || 'Biriktirilgan fayl') }}</span>
                    <span class="file-chip-meta">Yuklab olish</span>
                  </div>
                  <div class="download-btn"><i class="fa-solid fa-download"></i></div>
                </a>
              </div>
            </details>
          </div>

          <!-- META GRID -->
          <div class="meta-grid section-card">
            <!-- Status -->
            <div class="meta-field">
              <div class="meta-icon">
                <span class="material-symbols-outlined">flag</span>
              </div>
              <div>
                <div class="meta-label">Status</div>
                <div class="meta-value">
                  <span
                    class="status-pill"
                    :class="statusClass"
                  >
                    {{ task.status || '—' }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Dates -->
            <div class="meta-field">
              <div class="meta-icon">
                <span class="material-symbols-outlined">calendar_today</span>
              </div>
              <div>
                <div class="meta-label">Dates</div>
                <div class="meta-value">
                  <span class="pill pill-created">
                    Created · {{ startDate }}
                  </span>
                  <span 
                    class="pill pill-deadline" 
                    :class="{'editable-pill': task.user_id == userId}"
                    @click="task.user_id == userId ? mainTaskModal = true : null"
                    :title="task.user_id == userId ? 'Muddatni uzaytirish' : ''"
                  >
                    Deadline · {{ dueDate }}
                    <i v-if="task.user_id == userId" class="fa-solid fa-pen ms-1" style="font-size: 10px;"></i>
                  </span>
                </div>
              </div>
            </div>

            <!-- Assignees -->
            <div class="meta-field">
              <div class="meta-icon">
                <span class="material-symbols-outlined">group</span>
              </div>
              <div>
                <div class="meta-label">Assignees</div>
                <div class="meta-value">
                  <span
                    v-if="!assignees.length"
                    class="pill-outline"
                  >
                    No members
                  </span>
                  <span
                    v-else
                    v-for="m in assignees"
                    :key="m.user_id"
                    class="assignee-pill"
                    :title="m.user_fullname"
                  >
                    <span class="assignee-dot"></span>
                    ID: {{ m.user_id }} · {{ m.process || 'Ijro' }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Priority -->
            <div class="meta-field">
              <div class="meta-icon">
                <span class="material-symbols-outlined">bolt</span>
              </div>
              <div>
                <div class="meta-label">Priority</div>
                <div class="meta-value">
                  <span
                    class="priority-pill"
                    :class="priorityClass"
                  >
                    {{ displayPriority }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Comments -->
            <div class="meta-field">
              <div class="meta-icon">
                <span class="material-symbols-outlined">chat</span>
              </div>
              <div>
                <div class="meta-label">Comments</div>
                <div class="meta-value">
                  <span class="pill pill-comments">
                    {{ task.comments_count || 0 }} comments
                  </span>
                  <span
                    v-if="task.unread_count"
                    class="pill pill-unread"
                  >
                    {{ task.unread_count }} new
                  </span>
                </div>
              </div>
            </div>

            <!-- Check status -->
            <div class="meta-field">
              <div class="meta-icon">
                <span class="material-symbols-outlined">verified</span>
              </div>
              <div>
                <div class="meta-label">Check</div>
                <div class="meta-value">
                  <span
                    class="pill pill-check"
                    :class="{ 'pill-check--done': task.is_checked }"
                  >
                    {{ task.is_checked ? 'Checked' : 'Not checked' }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- CONTRIBUTORS -->
          <div class="section-card contributors-card">
            <div
              class="section-header section-header--toggle"
              role="button"
              tabindex="0"
              :aria-expanded="contributorsOpen.toString()"
              @click="contributorsOpen = !contributorsOpen"
              @keydown.enter.prevent="contributorsOpen = !contributorsOpen"
              @keydown.space.prevent="contributorsOpen = !contributorsOpen"
            >
              <div class="section-header-left">
                <h2>Ishtirokchilar</h2>
                <span class="section-hint" style="margin-left: 10px;">
                  {{ contributors.length }} ishtirokchi
                </span>
              </div>

              <div class="contributors-head-right">
                <!-- Yig‘ilgan avatarlar (yopiq holatda ham ko‘rinadi) -->
                <div class="contributor-stack">
                  <img
                    v-for="(c, i) in contributors.slice(0, 5)"
                    :key="c.user_id"
                    :src="contributorAvatar(c)"
                    :alt="c.name"
                    :title="c.name"
                    class="contributor-stack-img"
                    :style="{ marginLeft: i === 0 ? '0' : '-10px', zIndex: 5 - i }"
                    @error="handleAvatarError"
                  />
                  <span v-if="contributors.length > 5" class="contributor-stack-more">
                    +{{ contributors.length - 5 }}
                  </span>
                </div>
                <span class="material-symbols-outlined toggle-icon" :class="{ open: contributorsOpen }">
                  expand_more
                </span>
              </div>
            </div>

            <transition name="collapse">
              <div v-show="contributorsOpen" class="contributors-body">
                <div v-if="!contributors.length" class="contributors-empty">
                  <span class="material-symbols-outlined">group_off</span>
                  Ishtirokchilar yo‘q
                </div>

                <div v-else class="contributors-list">
                  <div
                    v-for="c in contributors"
                    :key="c.user_id"
                    class="contributor-row"
                    :class="{ 'is-me': c.user_id === userId }"
                  >
                    <img
                      :src="contributorAvatar(c)"
                      :alt="c.name"
                      class="contributor-avatar"
                      @error="handleAvatarError"
                    />

                    <div class="contributor-info">
                      <div class="contributor-name text-truncate" :title="c.name">
                        {{ c.name }}
                        <span v-if="c.user_id === userId" class="contributor-me-tag">siz</span>
                      </div>
                      <div class="contributor-roles">
                        <span v-if="c.isCreator" class="contributor-role role-creator">
                          Muallif
                        </span>
                        <span
                          v-for="role in c.roles"
                          :key="role"
                          class="contributor-role"
                          :class="roleClass(role)"
                        >
                          {{ role === 'Rozilik' ? 'Nazorat/Rozilik' : role }}
                        </span>
                      </div>
                    </div>

                    <div class="contributor-stats">
                      <span v-if="c.comments" class="contributor-stat" :title="c.comments + ' ta izoh'">
                        <span class="material-symbols-outlined">chat_bubble</span>
                        {{ c.comments }}
                      </span>
                      <span v-if="c.subtasks" class="contributor-stat" :title="c.subtasks + ' ta subtask'">
                        <span class="material-symbols-outlined">checklist</span>
                        {{ c.subtasks }}
                      </span>
                      <span v-if="!c.comments && !c.subtasks" class="contributor-stat contributor-stat--idle">
                        —
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <!-- Subtask section -->
          <div class="section-card subtasks-card">
            <!-- Header (toggle) -->
            <div
              class="section-header section-header--toggle"
              role="button"
              tabindex="0"
              :aria-expanded="subtasksOpen.toString()"
              aria-controls="subtasks-content"
              @click="toggleSubtasks"
              @keydown.enter.prevent="toggleSubtasks"
              @keydown.space.prevent="toggleSubtasks"
            >
              <div class="section-header-left">
                <h2>Subtasks</h2>
                <span class="section-hint">
                  {{ card.subtasks?.length || 0 }} items
                </span>
              </div>
              <div class="d-flex align-items-center">
                <button
                  type="button"
                  class="btn-c btn--sm btn--ghost mr-2"
                  @click.stop="openCreateSubtask()"
                  aria-label="Add new subtask"
                  :disabled="task.user_id !== userId"
                  :title="task.user_id !== userId ? 'Faqat yaratuvchi qoshishi mumkin' : 'Yangi subtask qoshish'"
                >
                  <span class="material-symbols-outlined" aria-hidden="true">add</span>
                  Add
                </button>

                <span
                  class="material-symbols-outlined toggle-icon"
                  :class="{ open: subtasksOpen }"
                  aria-hidden="true"
                >
                  expand_more
                </span>
              </div>
            </div>

            <!-- Collapsible content -->
            <transition name="collapse">
              <div
                v-show="subtasksOpen"
                id="subtasks-content"
                class="subtasks-content"
              >

                <!-- Subtask form -->
                <div class="mb-2" v-if="subtaskForm">
                  <ul
                    class="subtasks-list"
                    role="list"
                    aria-label="Subtasks list"
                  >
                    <li
                      class="subtask-item st-form-item"
                      role="listitem"
                    >
                      <!-- left: done toggle -->
                      <div class="d-flex align-items-center justify-content-between gap-2 st-form-act">
                        <button class="btn btn-success" @click="saveSubtask()" aria-label="Mark as done">
                          Save
                          <i class="fa fa-check"></i>
                        </button>
                        <button class="btn btn-danger" @click="cancelForm()" aria-label="Delete subtask">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>

                      <!-- main content -->
                      <div class="subtask-main">
                        <div class="subtask-top">
                          <div class="subtask-title">
                            <input
                              v-model="subTaskName"
                              type="text"
                              class="subtask-input"
                              placeholder="Enter name..."
                              aria-label="Subtask name"
                              ref="subtaskNameInput"
                            />
                          </div>

                          <!-- actions -->
                          <div class="subtask-actions">
                            <!-- Quick extend deadline -->
                            <button
                              type="button"
                              class="icon-btn btn-c"
                              @click="openNewTskMdl($event, 'date')"
                              aria-label="Set deadline"
                              title="Set deadline"
                            >
                              <span class="material-symbols-outlined" aria-hidden="true">date_range</span>
                            </button>

                            <!-- Assign -->
                            <button
                              type="button"
                              class="icon-btn btn-c"
                              @click="openNewTskMdl($event, 'assignee', st)"
                              aria-label="Assign members"
                              title="Ijrochi biriktirish"
                            >
                              <span class="material-symbols-outlined" aria-hidden="true">person_add</span>
                            </button>

                            <!-- More menu (accessible) -->
                            <div class="more-menu" @keydown.esc="openMenu = false">
                              <button
                                type="button"
                                class="icon-btn"
                                aria-haspopup="menu"
                                :aria-controls="`subtask-menu-${i}`"
                                aria-label="More actions"
                                title="More"
                              >
                                <span class="material-symbols-outlined" aria-hidden="true">more_vert</span>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- meta row -->
                        <div class="subtask-meta">
                          <div>
                            <!-- description (compact) -->
                            <input
                              v-model="subTaskDescription"
                              type="text"
                              class="subtask-input"
                              placeholder="Enter description..."
                              aria-label="Subtask description"
                            />
                          </div>

                          <div class="d-flex align-items-center gap-2 flex-wrap">
                            <div class="meta-chip pill pill-deadline">
                              <span class="material-symbols-outlined" aria-hidden="true">event</span>
                              <span class="meta-text">{{ newSubDate.length > 0 ? formatDate(newSubDate[newSubDate.length-1]) : 'No deadline set' }}</span>
                            </div>

                            <div class="meta-chip assignee-pill">
                              <span class="assignee-dot"></span>
                              <span class="material-symbols-outlined" aria-hidden="true">group</span>
                              <span class="meta-text">{{ newSubAssignee.length > 0 ? newSubAssignee.length + ' bajaruvchi' : 'Unassigned' }}</span>
                            </div>

                            <!-- <div class="meta-chip" v-else>
                              <span class="material-symbols-outlined" aria-hidden="true">person_off</span>
                              <span class="meta-text">Unassigned</span>
                            </div> -->
                          </div>

                        </div>

                      </div>
                    </li>
                  </ul>
                </div>

                <!-- Empty state -->
                <div v-if="!card.subtasks || card.subtasks.length === 0" class="subtasks-empty" role="status" aria-live="polite">
                  <span class="material-symbols-outlined" aria-hidden="true">playlist_add</span>
                  No subtasks yet
                </div>

                <!-- List -->
                <ul
                  v-else
                  class="subtasks-list"
                  role="list"
                  aria-label="Subtasks list"
                >
                  <li
                    v-for="(st, i) in card.subtasks"
                    :key="st.id || `${st.name}-${i}`"
                    class="subtask-item"
                    :class="{
                      'is-created': st.created,
                      'is-done': !!st.done
                    }"
                    role="listitem"
                  >
                    <!-- left: done toggle — faqat shu subtaskning IJROCHISI (Ijro) belgilay oladi -->
                    <button
                      v-if="isSubtaskExecutor(st)"
                      type="button"
                      class="subtask-check"
                      :aria-pressed="!!st.done || st.status === 'Bajarildi'"
                      :aria-label="(st.done || st.status === 'Bajarildi') ? 'Mark as not done' : 'Mark as done'"
                      @click="toggleDone(i)"
                    >
                      <span class="material-symbols-outlined" aria-hidden="true" :class="{ 'text-success': st.done || st.status === 'Bajarildi' }">
                        {{ (st.done || st.status === 'Bajarildi') ? 'check_circle' : 'radio_button_unchecked' }}
                      </span>
                    </button>
                    <!-- Agar ijrochi bo'lmasa, faqat holatni ko'rsatish -->
                    <div v-else class="subtask-check-readonly d-flex align-items-center me-2">
                      <span class="material-symbols-outlined" aria-hidden="true" :class="{ 'text-success': st.done || st.status === 'Bajarildi', 'text-muted': !st.done && st.status !== 'Bajarildi' }" style="font-size: 20px;">
                        {{ (st.done || st.status === 'Bajarildi') ? 'check_circle' : 'radio_button_unchecked' }}
                      </span>
                    </div>

                    <!-- main content -->
                    <div class="subtask-main">
                      <div class="subtask-top">
                        <div class="subtask-title" :title="st.name">
                          <span class="subtask-name">{{ st.name }}</span>
                        </div>

                        <!-- actions -->
                        <div class="subtask-actions">

                          <button
                            type="button"
                            class="icon-btn btn-c"
                            @click="openModal($event, 'date', st)"
                            aria-label="Set deadline"
                            :title="task.user_id !== userId ? 'Faqat yaratuvchi o\'zgartira oladi' : 'Muddat belgilash'"
                            :disabled="task.user_id !== userId"
                            :class="{ 'opacity-50 cursor-not-allowed': task.user_id !== userId }"
                          >
                            <span class="material-symbols-outlined" aria-hidden="true">date_range</span>
                          </button>

                          <!-- Assign -->
                          <button
                            type="button"
                            class="icon-btn btn-c"
                            @click="openModal($event, 'assignee', st)"
                            aria-label="Assign members"
                            :title="task.user_id !== userId ? 'Faqat yaratuvchi o\'zgartira oladi' : 'Ijrochi biriktirish'"
                            :disabled="task.user_id !== userId"
                            :class="{ 'opacity-50 cursor-not-allowed': task.user_id !== userId }"
                          >
                            <span class="material-symbols-outlined" aria-hidden="true">person_add</span>
                          </button>

                          <!-- More menu (accessible) -->
                          <div class="more-menu" @keydown.esc="openMenu = false">
                            <button
                              type="button"
                              class="icon-btn"
                              aria-haspopup="menu"
                              aria-label="Delete"
                              :title="task.user_id !== userId ? 'Faqat yaratuvchi o\'zgartira oladi' : 'O\'chirish'"
                              @click="deleteSubTask(st.id)"
                              :disabled="task.user_id !== userId"
                              :class="{ 'opacity-50 cursor-not-allowed': task.user_id !== userId }"
                            >
                              <span class="material-symbols-outlined" :style="task.user_id !== userId ? 'color: #ccc;' : 'color: #ff6b6b;'" aria-hidden="true">delete</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- meta row -->
                      <div class="subtask-meta">
                        <div>
                          <!-- description (compact) -->
                          <p v-if="st.description" class="subtask-desc">
                            {{ st.description }}
                          </p>
                        </div>

                        <div class="d-flex align-items-center gap-2 flex-wrap mt-1">
                          <span v-if="st.status === 'new' || (!st.status && !st.done)" class="status-pill status-pill--jarayonda" aria-label="Jarayonda">Jarayonda</span>
                          <span v-else-if="st.status === 'Bajarildi' || st.done" class="status-pill status-pill--bajarildi" aria-label="Bajarildi">Bajarildi</span>

                          <div class="meta-chip pill pill-deadline" :title="'Deadline: ' + st.deadline">
                            <span class="material-symbols-outlined" aria-hidden="true">event</span>
                            <span class="meta-text">{{ st.deadline || 'Belgilanmagan' }}</span>
                          </div>

                          <div class="meta-chip assignee-pill" v-if="st.assignees?.length" :title="membersLabel(st.assignees)">
                            <span class="assignee-dot"></span>
                            <span class="material-symbols-outlined" aria-hidden="true">group</span>
                            <span class="meta-text">{{ st.assignees.length }}ta
                              bajaruvchi</span>
                          </div>

                          <div class="meta-chip" v-else>
                            <span class="material-symbols-outlined" aria-hidden="true">person_off</span>
                            <span class="meta-text">Ijrochi belgilanmagan</span>
                          </div>
                        </div>

                      </div>

                    </div>
                  </li>
                </ul>

                <v-dialog v-model="newTaskModal" max-width="450" class="subtask-edit-dialog">
                  <v-card class="rounded-lg shadow-sm">
                    <v-card-title class="d-flex justify-content-between align-items-center px-4 pt-4 pb-2 border-bottom">
                      <strong class="text-h6 fs-16">{{ modalType === 'assignee' ? "Ijrochi qo'shish" : modalType === 'date' ? 'Muddat belgilash' : 'Priority' }}</strong>
                      <v-btn icon="mdi-close" variant="text" density="comfortable" @click="newTaskModal = false"></v-btn>
                    </v-card-title>

                    <v-card-text class="px-4 py-3">
                      <div v-if="modalType === 'assignee'" class="subtask-assignee-section p-0">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <span class="fs-13 text-muted">Kengroq qidiruv</span>
                          <v-switch v-model="isWideSearchModel" color="primary" density="compact" hide-details inset></v-switch>
                        </div>

                        <div class="subtask-assignee-form">
                          <v-autocomplete
                            v-model="newMember.user_id"
                            :items="availableEmployeesNT"
                            :disabled="isUpdating"
                            color="primary"
                            item-title="name"
                            item-value="id"
                            label="Xodimni tanlang"
                            prepend-inner-icon="mdi-account-search"
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            class="subtask-assignee-autocomplete mb-3 w-100"
                          >
                            <template v-slot:selection="{ item, attrs }">
                              <v-chip v-bind="attrs" :prepend-avatar="getEmployeeAvatar(item.raw.id)" size="small" label class="subtask-selected-chip">
                                {{ item.raw.name }}
                              </v-chip>
                            </template>
                            <template v-slot:item="{ props, item }">
                              <v-list-item v-bind="props" :prepend-avatar="getEmployeeAvatar(item.raw.id)" :subtitle="item.raw.group || 'Guruh yo‘q'" :title="item.raw.name" density="compact"></v-list-item>
                            </template>
                          </v-autocomplete>

                          <v-select
                            v-model="newMember.process"
                            :items="availableProcessesNT"
                            label="Jarayon"
                            :disabled="!newMember.user_id"
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            class="subtask-process-select mb-3"
                          ></v-select>

                          <v-btn color="primary" block :disabled="!newMember.user_id || !newMember.process" @click="addAssignee" class="subtask-add-btn text-none" elevation="0">
                            <v-icon start>mdi-plus</v-icon> Ro'yxatga qo‘shish
                          </v-btn>
                        </div>

                        <div class="subtask-selected-members mt-4" v-if="newSubAssignee?.length > 0">
                          <div class="mb-2 fw-medium text-muted fs-13">Biriktirilgan xodimlar</div>
                          <div class="subtask-member-list">
                            <v-card v-for="(member, index) in newSubAssignee" :key="index" variant="outlined" class="mb-2 px-3 py-2 d-flex align-items-center justify-content-between bg-light">
                              <div class="d-flex align-items-center gap-3">
                                <v-avatar size="32">
                                  <v-img :src="getEmployeeAvatar(member.user_id)" @error="handleAvatarError"></v-img>
                                </v-avatar>
                                <div>
                                  <div class="fs-13 fw-medium mb-1" style="line-height:1">{{ getEmployeeName(member.user_id) }}</div>
                                  <div class="fs-12 text-muted" style="line-height:1">{{ member.process }}</div>
                                </div>
                              </div>
                              <v-btn icon="mdi-delete-outline" color="error" variant="text" size="small" density="comfortable" @click="removeMemberNewTask(index)"></v-btn>
                            </v-card>
                          </div>
                        </div>
                        <div v-else class="text-center text-muted fs-13 mt-4 py-3 bg-light rounded">
                          Hozircha xodim qo‘shilmagan
                        </div>
                      </div>

                      <div v-if="modalType === 'date'" class="pt-2">
                        <v-date-input
                          v-model="newSubDate"
                          multiple="range"
                          density="compact"
                          variant="outlined"
                          hide-details
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar-range"
                          clearable
                          label="Muddatni qo'shish"
                        />
                      </div>
                    </v-card-text>

                    <v-card-actions class="px-4 py-3 border-top bg-light justify-content-end">
                      <v-btn color="success" variant="flat" prepend-icon="mdi-check" @click="newTaskModal = false" class="text-none px-4">Yopish</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="showModal" max-width="450" class="subtask-edit-dialog">
                  <v-card class="rounded-lg shadow-sm">
                    <v-card-title class="d-flex justify-content-between align-items-center px-4 pt-4 pb-2 border-bottom">
                      <strong class="text-h6 fs-16">{{ modalType === 'assignee' ? "Ijrochi qo'shish (Tahrir)" : modalType === 'date' ? 'Muddat belgilash' : 'Priority' }}</strong>
                      <v-btn icon="mdi-close" variant="text" density="comfortable" @click="showModal = false"></v-btn>
                    </v-card-title>

                    <v-card-text class="px-4 py-3">
                      <div v-if="modalType === 'assignee'" class="subtask-assignee-section p-0">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <span class="fs-13 text-muted">Kengroq qidiruv</span>
                          <v-switch v-model="isWideSearchModel" color="primary" density="compact" hide-details inset></v-switch>
                        </div>

                        <div class="subtask-assignee-form">
                          <v-autocomplete
                            v-model="newMember.user_id"
                            :items="availableEmployees"
                            :disabled="isUpdating"
                            color="primary"
                            item-title="name"
                            item-value="id"
                            label="Xodimni tanlang"
                            prepend-inner-icon="mdi-account-search"
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            class="mb-3 w-100"
                          >
                            <template v-slot:selection="{ item, attrs }">
                              <v-chip v-bind="attrs" :prepend-avatar="getEmployeeAvatar(item.raw.id)" size="small" label>
                                {{ item.raw.name }}
                              </v-chip>
                            </template>
                            <template v-slot:item="{ props, item }">
                              <v-list-item v-bind="props" :prepend-avatar="getEmployeeAvatar(item.raw.id)" :subtitle="item.raw.group || 'Guruh yo‘q'" :title="item.raw.name" density="compact"></v-list-item>
                            </template>
                          </v-autocomplete>

                          <v-select
                            v-model="newMember.process"
                            :items="availableProcesses"
                            label="Jarayon"
                            :disabled="!newMember.user_id"
                            variant="outlined"
                            density="compact"
                            hide-details="auto"
                            class="mb-3"
                          ></v-select>

                          <v-btn color="primary" block :disabled="!newMember.user_id || !newMember.process" @click="addMember" class="text-none" elevation="0">
                            <v-icon start>mdi-plus</v-icon> Ro'yxatga qo‘shish
                          </v-btn>
                        </div>

                        <div class="subtask-selected-members mt-4" v-if="selectedMembers.length">
                          <div class="mb-2 fw-medium text-muted fs-13">Biriktirilgan xodimlar</div>
                          <div class="subtask-member-list">
                            <v-card v-for="(member, index) in selectedMembers" :key="index" variant="outlined" class="mb-2 px-3 py-2 d-flex align-items-center justify-content-between bg-light">
                              <div class="d-flex align-items-center gap-3">
                                <v-avatar size="32">
                                  <v-img :src="getEmployeeAvatar(member.user_id)" @error="handleAvatarError"></v-img>
                                </v-avatar>
                                <div>
                                  <div class="fs-13 fw-medium mb-1" style="line-height:1">{{ getEmployeeName(member.user_id) }}</div>
                                  <div class="fs-12 text-muted" style="line-height:1">{{ member.process }}</div>
                                </div>
                              </div>
                              <v-btn icon="mdi-delete-outline" color="error" variant="text" size="small" density="comfortable" @click="removeMember(index)"></v-btn>
                            </v-card>
                          </div>
                        </div>
                        <div v-else class="text-center text-muted fs-13 mt-4 py-3 bg-light rounded">
                          Hozircha xodim qo‘shilmagan
                        </div>
                      </div>

                      <div v-if="modalType === 'date'" class="pt-2">
                        <v-date-input
                          v-model="subTaskDate"
                          multiple="range"
                          density="compact"
                          variant="outlined"
                          hide-details
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar-range"
                          clearable
                          label="Muddatni qo'shish"
                        />
                      </div>
                    </v-card-text>

                    <v-card-actions class="px-4 py-3 border-top bg-light justify-content-end">
                       <v-btn color="grey-darken-1" variant="text" @click="showModal = false" class="text-none">Bekor qilish</v-btn>
                      <v-btn color="success" variant="flat" prepend-icon="mdi-check" @click="updateSubtask(modalType)" class="text-none px-4">Saqlash</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </div>
            </transition>
          </div>

          <!-- Summary / Info column -->
          <div 
            class="section-card subtasks-card" 
            @click="toggleTaskInfo" 
            :aria-expanded="taskInfoOpen.toString()"
          >
            <div class="section-header" style="margin-bottom: 0; height: 30px;">
              <div class="section-header-left">
                <h2>Task Info</h2>
                <span class="section-hint" style="margin-left: 10px;">
                  Quick overview of key details
                </span>
              </div>
              <span class="material-symbols-outlined toggle-icon" :class="{ 'open': taskInfoOpen }">
                expand_more
              </span>
            </div>

            <transition name="collapse">
              <div v-show="taskInfoOpen" class="subtasks-content" @click.stop>
                <div class="custom-fields-list" style="margin-top: 10px;">
              <div class="cf-row">
                <div class="cf-label">
                  <span class="material-symbols-outlined">person</span>
                  Topshiriq beruvchi
                </div>
                <div class="cf-placeholder">
                  {{ task.user_fullname || '—' }}
                </div>
              </div>

              <div class="cf-row">
                <div class="cf-label">
                  <span class="material-symbols-outlined">schedule</span>
                  Yaratildi
                </div>
                <div class="cf-placeholder">
                  {{ formatDateTime(task.created_at) }}
                </div>
              </div>

              <div class="cf-row">
                <div class="cf-label">
                  <span class="material-symbols-outlined">event</span>
                  Muddati
                </div>
                <div class="cf-placeholder cf-deadline">
                  {{ formatDateTime(task.deadline) }}
                </div>
              </div>

              <div class="cf-row">
                <div class="cf-label">
                  <span class="material-symbols-outlined">update</span>
                  Yangilandi
                </div>
                <div class="cf-placeholder">
                  {{ formatDateTime(task.updated_at) }}
                </div>
              </div>

              <div class="cf-add-row">
                <span class="material-symbols-outlined">add</span>
                Custom fields can be added later
              </div>
                </div>
              </div>
            </transition>
          </div>
        </section>

        <!-- DESCRIPTION + EXTRA INFO -->
        <section class="body-grid">
          <!-- Description -->
        </section>

        <!-- MAIN TASK DEADLINE MODAL (CUSTOM) -->
        <v-dialog v-model="mainTaskModal" max-width="360" content-class="elevation-0">
          <div class="custom-modal-content" style="margin: auto; width: 100%; border: none; box-shadow: none;">
            <div class="custom-modal-header">
              <h6>Muddatni uzaytirish</h6>
              <button class="close-btn" @click="mainTaskModal = false">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div class="custom-modal-body">
              <label class="custom-input-label">Yangi muddatni tanlang</label>
              <div class="custom-date-input-wrapper">
                <i class="fa-regular fa-calendar date-icon"></i>
                <input 
                  type="date" 
                  v-model="mainTaskDate" 
                  class="custom-date-input"
                />
              </div>
            </div>
            <div class="custom-modal-footer">
              <button class="custom-btn-cancel" @click="mainTaskModal = false">Bekor qilish</button>
              <button 
                class="custom-btn-save" 
                @click="updateMainTaskDeadline" 
                :disabled="isUpdatingDeadline"
              >
                <i v-if="isUpdatingDeadline" class="fa-solid fa-spinner fa-spin me-1"></i>
                <i v-else class="fa-solid fa-check me-1"></i> Saqlash
              </button>
            </div>
          </div>
        </v-dialog>
      </main>

      <!-- RIGHT: Activity panel (comments history + form) -->
      <aside class="activity-panel">
        <div class="activity-header">
          <span>Activity</span>
          <span class="material-symbols-outlined">tune</span>
        </div>

        <div class="activity-list" ref="activityList">
          <div
            v-if="!activityList.length"
            class="activity-empty"
          >
            No activity yet.
          </div>

           <div
              v-if="
                task.user_id === userId &&
                task.unread_count > 0 &&
                idx === (activityList.length - task.unread_count)
              "
              class="activity-unread-divider"
            >
              Unread messages
            </div>

          <div
            v-for="(item, idx) in activityList"
            :key="idx"
            class="chat-message-wrapper"
            :class="[item.isMine ? 'chat-mine' : 'chat-other', { 'chat-menu-active': msgMenu.item && msgMenu.item.id === item.id }]"
            @contextmenu="openMsgMenu($event, item)"
          >
            <!-- Avatar for others -->
            <img v-if="!item.isMine" :src="item.img" :title="item.author" class="chat-avatar" />

            <div class="chat-bubble">
              <div v-if="!item.isMine" class="chat-author" :style="{ color: getAuthorColor(item.author) }">{{ item.author }}</div>
              
              <div class="chat-files" v-if="item.files && item.files.length">
                <div v-for="(f, fIdx) in item.files" :key="fIdx" class="chat-file-item" @click="handleFileClick(f)">
                  
                  <div class="chat-file-thumb-wrapper">
                    <img v-if="isImage(f.name)" :src="f.url" class="chat-file-thumb" />
                    <div v-else class="chat-file-icon" style="margin: 0; width: 100%; height: 100%;">
                      <i class="fa-solid fa-file-pdf" v-if="isPdf(f.name)"></i>
                      <i class="fa-solid fa-file-lines" v-else></i>
                    </div>
                    <button type="button" @click.stop="forceDownload(f.url, f.name)" class="chat-file-overlay" title="Yuklab olish">
                      <i class="fa-solid fa-download"></i>
                    </button>
                  </div>
                  
                  <div class="chat-file-info">
                    <span class="chat-file-name" :title="f.name">{{ f.name }}</span>
                    <span class="chat-file-meta">
                      {{ f.size ? f.size + ' • ' : '' }}{{ isImage(f.name) ? 'Rasm' : 'Hujjat' }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="chat-text" v-if="item.text && editingCommentId !== item.id">{{ item.text }}</div>

              <!-- Inline tahrirlash -->
              <div v-if="editingCommentId === item.id" class="chat-edit" @contextmenu.stop>
                <textarea
                  ref="editInput"
                  v-model="editingText"
                  class="chat-edit-input"
                  rows="2"
                  @keydown.esc.prevent="cancelEditComment"
                  @keydown.enter.exact.prevent="saveEditComment(item)"
                ></textarea>
                <div class="chat-edit-actions">
                  <button type="button" class="chat-edit-btn cancel" @click="cancelEditComment">Bekor</button>
                  <button type="button" class="chat-edit-btn save" :disabled="isSavingEdit || !editingText.trim()" @click="saveEditComment(item)">
                    {{ isSavingEdit ? 'Saqlanmoqda...' : 'Saqlash' }}
                  </button>
                </div>
              </div>

              <div class="chat-time" v-if="editingCommentId !== item.id">
                {{ item.time }}
                <span v-if="item.edited" class="chat-edited-tag">· tahrirlangan</span>
                <!-- <i v-if="item.isMine" class="fa-solid fa-check-double ms-1" style="font-size: 10px; color: var(--task-accent);"></i> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Xabar kontekst menyusi (o'ng tugma) -->
        <template v-if="msgMenu.show">
          <div class="msg-menu-backdrop" @click="closeMsgMenu" @contextmenu.prevent="closeMsgMenu" @wheel="closeMsgMenu"></div>
          <div class="msg-context-menu" :style="{ top: msgMenu.y + 'px', left: msgMenu.x + 'px' }">
            <button type="button" class="msg-menu-item" @click="startEditComment(msgMenu.item)">
              <i class="fa-solid fa-pen"></i> Tahrirlash
            </button>
            <button type="button" class="msg-menu-item danger" @click="deleteComment(msgMenu.item)">
              <i class="fa-solid fa-trash"></i> O'chirish
            </button>
          </div>
        </template>

        <!-- COMMENT FORM -->
        <div class="activity-footer">
          <form @submit.prevent="sendComment(task.id)">
            <!-- File preview area (moved above the input) -->
            <div class="comment-files-container" v-if="commentFiles.length">
              <div
                v-for="(f, idx) in commentFiles" :key="idx"
                class="comment-file-preview"
              >
                <!-- Image thumbnail -->
                <img
                  v-if="isImage(f.name)"
                  :src="f.url"
                  alt="Preview"
                  class="file-thumb"
                  @click="openImageZoom(f)"
                />
                <!-- PDF or other file icon -->
                <div v-else class="file-icon-placeholder" @click="openPdf(f)" style="cursor: pointer;">
                  <i class="fa-solid fa-file-pdf" v-if="isPdf(f.name)"></i>
                  <i class="fa-solid fa-file-lines" v-else></i>
                </div>
                <!-- File name -->
                <span class="file-name">{{ f.name }}</span>
                <!-- Remove button -->
                <button
                  type="button"
                  class="file-remove-btn"
                  @click="removeFile(idx)"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>

            <div class="container-1">
              <!-- Attach icon -->
              <label
                for="file-comment"
                class="attach-label"
              >
                <i class="fa fa-paperclip"></i>
              </label>

              <div class="comment-main">

                <!-- PDF Modal -->
                <div
                  v-if="showPdfModal"
                  class="pdf-modal"
                >
                  <div class="pdf-controls">
                    <a
                      :href="pdfUrl"
                      target="_blank"
                      :download="pdfFileName"
                      title="Yuklab olish"
                    >
                      <i class="fa fa-download"></i>
                    </a>
                    <button
                      type="button"
                      @click="closePdfModal"
                      title="Yopish"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>

                  <iframe
                    :src="pdfUrl"
                    frameborder="0"
                    class="pdf-frame"
                  ></iframe>
                </div>

                <!-- Full image modal -->
                <div
                  v-if="showImageModal"
                  class="image-modal modern-image-modal"
                  @wheel.prevent="handleImageWheel"
                >
                  <div class="modern-image-controls">
                    <button type="button" @click="zoomIn" title="Kattalashtirish (Ctrl + Scroll)">
                      <i class="fa-solid fa-magnifying-glass-plus"></i>
                    </button>
                    <button type="button" @click="zoomOut" title="Kichiklashtirish">
                      <i class="fa-solid fa-magnifying-glass-minus"></i>
                    </button>
                    <button type="button" @click="rotateImage" title="Aylantirish">
                      <i class="fa-solid fa-rotate-right"></i>
                    </button>
                    <button type="button" @click="forceDownload(zoomFileObj.url, zoomFileObj.name)" class="modern-download-btn" title="Yuklab olish">
                      <i class="fa-solid fa-download"></i>
                    </button>
                    <div class="divider"></div>
                    <button type="button" @click="showImageModal = false" title="Yopish" class="modern-close-btn">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>

                  <img
                    :src="zoomImageUrl"
                    alt="Full Image"
                    class="zoomable-image"
                    :style="{ transform: `scale(${zoomLevel}) rotate(${rotationAngle}deg)` }"
                  />
                </div>

                <!-- Text input -->
                <input
                  v-model="commentMessage"
                  type="text"
                  class="form-control comment-input"
                  placeholder="Matnni kiriting"
                  @paste="handlePaste"
                  required
                />
              </div>

              <!-- Hidden file input -->
              <input
                ref="fileInput"
                @change="commentFileUpload"
                type="file"
                multiple
                name="file-comment"
                id="file-comment"
                style="display: none"
              />

              <!-- Send button -->
              <button
                type="submit"
                class="comment-send-btn"
                :disabled="isSendingComment"
              >
                <i
                  v-if="!isSendingComment"
                  class="fa-solid fa-paper-plane"
                  style="font-size: 18px"
                ></i>
                <i
                  v-else
                  class="fa-solid fa-spinner fa-spin"
                  style="font-size: 18px"
                ></i>
              </button>
            </div>
          </form>
        </div>
      </aside>

    </div>
  </div>
</template>

<script>
import Editor from 'primevue/editor'
import echo from "@/plugins/echo"
import api from '@/services/api';
import { nextTick } from 'vue'
import { VDateInput } from 'vuetify/labs/VDateInput'
import Swal from "sweetalert2";

export default {
  name: 'TaskDialog',

  components: {
    Editor,
    VDateInput,
  },

  emits: ['send-comment', 'update-description', 'accept-task', 'delete-task', 'update-task', 'close-dialog', 'update-column', 'redirect', 'comment-added', 'comment-updated', 'comment-deleted'],

  props: {
    task: {
      type: Object,
      required: true,
    },
    getEmployeeAvatar: {
      type: Function,
      default: () => null,
    },
    getEmployeeName: {
      type: Function,
      default: () => 'Unknown',
    },
    canMoveBack: {
      type: Function,
      required: true,
    },
    canMoveNext: {
      type: Function,
      required: true,
    },
    isWideSearch: {
      type: Boolean,
      default: false,
    },
    myEmployees: {
      type: Array,
      default: () => [],
    },
    employees: {
      type: Array,
      default: () => [],
    },
    processes: {
      type: Array,
      default: () => [],
    },
  },

  emits: [
    'update-description',
    'close',
    'redirect',
    'update-column',
    'copy-task',
    'edit-task',
    'delete-task',
    'get-help',
    'update:isWideSearch'
  ],

  data() {
    return {
      mainTaskModal: false,
      mainTaskDate: '',
      isUpdatingDeadline: false,
      selectedStID: null,
      newSubDate: [],
      newSubAssignee: [],
      newTaskModal: false,
      subTaskAssignee: [],
      subtaskForm: false,
      subTaskName: '',
      subTaskDescription: '',
      subTaskDate: [],
      showModal: false,
      modalX: 0,
      modalY: 0,
      modalType: null,
      newMember: {
        user_id: null,
        process: null,
      },
      openMenu: false,
      subtasksOpen: false,
      taskInfoOpen: false,
      contributorsOpen: false,
      card: {
        subtasks: [],
      },
      localDescription: this.task.description || '',
      userId: null,

      localComments: this.comments ? [...this.comments] : [],
      // comment form state
      commentMessage: '',
      commentFiles: [],
      isSendingComment: false,
      // Activity xabari uchun kontekst menyu (o'ng tugma) va tahrirlash holati
      msgMenu: { show: false, x: 0, y: 0, item: null },
      editingCommentId: null,
      editingText: '',
      isSavingEdit: false,
      showPdfModal: false,
      pdfUrl: '',
      pdfFileName: '',
      showImageModal: false,
      zoomImageUrl: '',
      zoomFileObj: null,
      zoomLevel: 1,
      rotationAngle: 0,
    }
  },

  computed: {
    availableEmployeesNT() {
      const selectedIds = this.newSubAssignee.map((member) => member.user_id);
      const source = this.isWideSearchModel ? this.employees : this.myEmployees;
      return source.filter(
        (employee) => !selectedIds.includes(employee.id)
      );
    },
    availableProcessesNT() {
      const singleAssignmentProcesses = ["Rozilik", "Ijro"];
      const usedProcesses = this.newSubAssignee
        .filter((member) => singleAssignmentProcesses.includes(member.process))
        .map((member) => member.process);
      return this.processes.filter(
        (process) =>
          !usedProcesses.includes(process) ||
          !singleAssignmentProcesses.includes(process)
      );
    },

    availableEmployees() {
      const selectedIds = this.selectedMembers.map((member) => member.user_id);
      const source = this.isWideSearchModel ? this.employees : this.myEmployees;
      return source.filter(
        (employee) => !selectedIds.includes(employee.id)
      );
    },
    availableProcesses() {
      const singleAssignmentProcesses = ["Rozilik", "Ijro"];
      const usedProcesses = this.selectedMembers
        .filter((member) => singleAssignmentProcesses.includes(member.process))
        .map((member) => member.process);
      return this.processes.filter(
        (process) =>
          !usedProcesses.includes(process) ||
          !singleAssignmentProcesses.includes(process)
      );
    },
    isWideSearchModel: {
      get() {
        return this.$props.isWideSearch;
      },
      set(value) {
        this.$emit('update:isWideSearch', value);
      }
    },
    startDate() {
      return this.formatDate(this.task.created_at)
    },
    dueDate() {
      return this.formatDate(this.task.deadline)
    },
    assignees() {
      return Array.isArray(this.task.members) ? this.task.members : []
    },
    // Topshiriqda qatnashgan barcha shaxslar: muallif + a'zolar + subtask ijrochilari + izoh yozganlar
    contributors() {
      const map = new Map();

      const upsert = (userId, { name, avatar, role, isCreator } = {}) => {
        if (userId === null || userId === undefined || userId === '') return null;
        const key = Number(userId);
        if (Number.isNaN(key)) return null;

        let entry = map.get(key);
        if (!entry) {
          entry = {
            user_id: key,
            name: '',
            avatar: '',
            roles: [],
            isCreator: false,
            comments: 0,
            subtasks: 0,
          };
          map.set(key, entry);
        }
        if (name && !entry.name) entry.name = name;
        if (avatar && !entry.avatar) entry.avatar = avatar;
        if (role && !entry.roles.includes(role)) entry.roles.push(role);
        if (isCreator) entry.isCreator = true;
        return entry;
      };

      const fullName = (o) =>
        o?.full_name ||
        o?.user_fullname ||
        [o?.firstname, o?.lastname].filter(Boolean).join(' ');

      // 1) Topshiriq muallifi
      upsert(this.task.user_id, {
        name: this.task.user_fullname,
        avatar: this.task.user_avatar || this.task.avatar,
        isCreator: true,
      });

      // 2) Topshiriq a'zolari (Ijro / Rozilik / Malumot / Test)
      this.assignees.forEach((m) => {
        upsert(m.user_id, { name: fullName(m), avatar: m.avatar, role: m.process });
      });

      // 3) Subtask ijrochilari
      (this.card.subtasks || []).forEach((st) => {
        (st.assignees || []).forEach((a) => {
          const entry = upsert(a.user_id, {
            name: fullName(a),
            avatar: a.avatar,
            role: a.process,
          });
          if (entry) entry.subtasks += 1;
        });
      });

      // 4) Izoh yozgan foydalanuvchilar (bu yerda avatar `user.img` da keladi)
      (this.localComments || []).forEach((c) => {
        const entry = upsert(c.user_id ?? c.user?.id, {
          name: c.user?.name,
          avatar: c.user?.img || c.user?.avatar,
        });
        if (entry) entry.comments += 1;
      });

      return [...map.values()]
        .map((c) => {
          if (c.name) return c;
          const resolved = this.getEmployeeName(c.user_id);
          return {
            ...c,
            name: resolved && resolved !== 'Unknown' ? resolved : `ID: ${c.user_id}`,
          };
        })
        .sort((a, b) => {
          if (a.isCreator !== b.isCreator) return a.isCreator ? -1 : 1;
          return b.comments + b.subtasks - (a.comments + a.subtasks);
        });
    },
    activityList() {
      return (this.localComments || []).map(c => {
        let files = [];
        if (c.files && Array.isArray(c.files)) {
          files = c.files;
        } else if (c.file_name) {
          try {
            let parsed = JSON.parse(c.file_name);
            if (Array.isArray(parsed)) files = parsed;
            else files = [c.file_name];
          } catch(e) {
            files = [c.file_name];
          }
        }
        
        return {
          id: c.id,
          isMine: (c.user_id || c.user?.id) === this.userId,
          edited: !!(c.edited || c.is_edited),
          img: `https://api.task-board.uz/storage/user/avatar/${c.user?.img}`,
          author: c.user?.name || 'User',
          text: c.message || '',
          files: files.map(f => {
            const fName = typeof f === 'string' ? f : (f.file_name || f.name || String(f));
            let fUrl = '';
            
            if (typeof f === 'string') {
               fUrl = this.$store.state.fileUrl ? (this.$store.state.fileUrl + `task_comments/${f}`) : `https://api.task-board.uz/storage/task_comments/${f}`;
            } else if (f.url) {
               fUrl = f.url;
            } else {
               const fPath = f.path || `task_comments/${fName}`;
               fUrl = this.$store.state.fileUrl ? (this.$store.state.fileUrl + fPath) : `https://api.task-board.uz/storage/${fPath}`;
            }

            let fSizeStr = '';
            if (f.file_size) {
               const kb = f.file_size / 1024;
               if (kb > 1024) {
                 fSizeStr = (kb / 1024).toFixed(2) + ' MB';
               } else {
                 fSizeStr = Math.round(kb) + ' KB';
               }
            }

            return {
              name: fName,
              url: fUrl,
              size: fSizeStr
            };
          }),
          time: new Date(c.created_at)
                .toLocaleString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                })
                .replace(',', ''),
        };
      });
    },
    displayPriority() {
      return this.task.priority || 'Low'
    },
    priorityClass() {
      const p = (this.task.priority || 'Low').toLowerCase()
      if (p === 'high') return 'priority-pill--high'
      if (p === 'medium') return 'priority-pill--medium'
      return 'priority-pill--low'
    },
    statusClass() {
      const s = (this.task.status || '').toLowerCase()
      if (s.includes('yakun')) return 'status-pill--done'
      if (s.includes('jarayon')) return 'status-pill--progress'
      if (s.includes('tekshir')) return 'status-pill--review'
      if (s.includes('rad') || s.includes('bekor') || s.includes('cancel'))
        return 'status-pill--rejected'
      return 'status-pill--progress'
    },
  },

  watch: {
    'task.description'(val) {
      if (val !== this.localDescription) {
        this.localDescription = val || ''
      }
    },
    localDescription(val) {
      this.$emit('update-description', val)
    },
    
    task: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.id) {
          if (!oldVal || newVal.id !== oldVal.id) {
            this.fetchComments(newVal.id);
            this.$nextTick(() => {
              this.setupEcho();
            });
          }
        }
      }
    }
  },

  beforeUnmount() {
    this.teardownEcho();
  },

  mounted() {
    this.getSubtasks();

    const user = this.$store.state.user
    if (user) {
      try {
        this.userId = user.id
      } catch (e) {
        this.userId = null
      }
    }
  },

  methods: {
    async updateMainTaskDeadline() {
      if (!this.mainTaskDate) {
        Swal.fire({
          icon: 'warning',
          title: 'Diqqat',
          text: 'Iltimos, yangi muddatni tanlang',
        });
        return;
      }
      
      this.isUpdatingDeadline = true;
      const newDeadlineStr = this.mainTaskDate;
      
      const payload = new FormData();
      payload.append("deadline", newDeadlineStr);

      try {
        await api.post("/add-deadline/" + this.task.id, payload);
        this.task.deadline = newDeadlineStr;
        this.mainTaskModal = false;
        Swal.fire({
          icon: 'success',
          title: 'Muvaffaqiyat',
          text: 'Topshiriq muddati uzaytirildi',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
        this.$emit('update-task');
      } catch (e) {
        console.error("Muddatni o'zgartirishda xato:", e);
        Swal.fire({
          icon: 'error',
          title: 'Xato',
          text: "Topshiriq muddatini o'zgartirib bo'lmadi",
        });
      } finally {
        this.isUpdatingDeadline = false;
      }
    },
    getAuthorColor(authorName) {
      if (!authorName) return '#405189';
      const colors = [
        '#E53935', '#D81B60', '#8E24AA', '#5E35B1', '#3949AB', 
        '#1E88E5', '#039BE5', '#00ACC1', '#00897B', '#43A047', 
        '#7CB342', '#F4511E', '#6D4C41', '#546E7A'
      ];
      let hash = 0;
      for (let i = 0; i < authorName.length; i++) {
        hash = authorName.charCodeAt(i) + ((hash << 5) - hash);
      }
      hash = Math.abs(hash);
      return colors[hash % colors.length];
    },
    getFileUrl(path) {
      if (!path) return '#';
      if (path.startsWith('http')) return path;
      const baseUrl = this.$store.state.fileUrl || 'https://api.task-board.uz/storage/';
      return baseUrl.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
    },
    setupEcho() {
      if (!this.task || !this.task.id) return;
      this.teardownEcho();
      echo.channel(`task.${this.task.id}`)
      .listen(".TaskMessage", (e) => {
        if (!this.localComments.some(c => c.id === e.id)) {
          this.localComments.push(e);
          this.scrollActivityToBottom();
          this.$emit('comment-added', this.task.id);
        }
      });
    },
    teardownEcho() {
      if (this.task && this.task.id) {
        echo.leaveChannel(`task.${this.task.id}`);
      }
    },
    async fetchComments(taskId) {
      try {
        const res = await api.get("/task-comments", {
          params: { task_id: taskId },
          meta: { al: false }
        });
        this.localComments = res.data.comments || [];
        this.$nextTick(() => {
          this.scrollActivityToBottom();
        });
      } catch (e) {
        console.error("Comments yuklashda xato:", e);
      }
    },
    acceptTask() {
      this.$emit("accept-task", this.task.id);
    },
    deleteSubTask(subTaskId) {
      Swal.fire({
        title: "O‘chirish",
        text: "Ushbu topshiriqni o‘chirmoqchimisiz?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ha, o‘chirilsin",
        cancelButtonText: "Bekor qilish",
      })
      .then((result) => {
        if (result.isConfirmed) {
          api.post('/delete-subtask/' + subTaskId)
          .then(()=>{
            this.getSubtasks();
          })
        }
      })
    },
    updateSubtask(modalType) {
      let params = {};
      if (modalType === 'assignee') {
        params = {
          members: this.selectedMembers,
        };
      }else if (modalType === 'date') {
        const toYMD = d => {
          const x = new Date(d)
          const y = x.getFullYear()
          const m = String(x.getMonth() + 1).padStart(2, '0')
          const day = String(x.getDate()).padStart(2, '0')
          return `${y}-${m}-${day}`
        }
        const dates = Array.isArray(this.subTaskDate)
        ? this.subTaskDate.map(toYMD)
        : []
        
        params = {
          dates: dates,
        };
      }

      api.post('/update-subtask/' + this.selectedStID, params)
      .then(res => {
        this.getSubtasks();
        this.showModal = false;
        console.log(res);
        
      })
    },  
    addAssignee() {
      this.newSubAssignee.push(
        this.newMember
      );
      this.newMember = {
        user_id: null,
        process: null,
      };
    },
    addMember() {
      this.selectedMembers.push(
        this.newMember
      );
      this.newMember = {
        user_id: null,
        process: null,
      };
    },
    removeMemberNewTask(index) {
      this.subTaskAssignee.splice(index, 1);
    },
    removeMember(index) {
      this.selectedMembers.splice(index, 1);
    },
    openNewTskMdl(event, type) {
      const btn = event.currentTarget;
      const btnRect = btn.getBoundingClientRect();

      // Fixed position yordamida tashqariga chiqish
      this.modalY = btnRect.bottom + 6;
      this.modalX = window.innerWidth - btnRect.right;

      this.modalType = type;
      this.newTaskModal = true;
    },

    openModal(event, type, subTask) {
      this.selectedStID = subTask.id;
      const btn = event.currentTarget;
      const btnRect = btn.getBoundingClientRect();

      // Fixed position yordamida tashqariga chiqish
      this.modalY = btnRect.bottom + 6;
      this.modalX = window.innerWidth - btnRect.right;

      this.modalType = type;
      this.showModal = true;

      if (type === 'assignee') {
        this.selectedMembers = subTask?.assignees || [];
      }
    },

    getSubtasks() {
      api.get('/get-subtasks/'+this.task.id, {meta: { al: false }})
      .then(res => {
        this.card.subtasks = res.data.data || []
      })
    },
    toggleSubtasks() {
      this.subtasksOpen = !this.subtasksOpen;
    },
    toggleTaskInfo() {
      this.taskInfoOpen = !this.taskInfoOpen;
    },
    openCreateSubtask() {
      this.subtasksOpen = true;
      this.subtaskForm = true;
      nextTick(() => {
        this.$refs.subtaskNameInput?.focus()
      })
    },
    cancelForm() {
      this.subtaskForm = false;
    },
    saveSubtask() {
      this.subtaskForm = false;
      
      const toYMD = d => {
        const x = new Date(d)
        const y = x.getFullYear()
        const m = String(x.getMonth() + 1).padStart(2, '0')
        const day = String(x.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      }

      const dates = Array.isArray(this.newSubDate)
        ? this.newSubDate.map(toYMD)
        : []
        
      
      api.post('/create-subtask/' + this.task.id, {
        name: this.subTaskName,
        description: this.subTaskDescription,
        dates: dates,
        members: this.newSubAssignee,
      }).then(res => {
        this.card.subtasks.unshift(res.data.data);
        // reset form
        this.subTaskName = '';
        this.subTaskDescription = '';
        this.newSubDate = [];
        this.newSubAssignee = [];
        this.newMember = {
          user_id: null,
          process: null,
        };
      })
      // TODO: save subtask logic
    },

    // Joriy foydalanuvchi shu subtaskning ijrochisimi (Ijro roli)?
    isSubtaskExecutor(st) {
      return (st.assignees || []).some(
        (m) => m.user_id === this.userId && m.process === "Ijro"
      );
    },
    toggleDone(index) {
      const st = this.card.subtasks[index];
      const isCurrentlyDone = st.done || st.status === 'Bajarildi';
      const newStatus = isCurrentlyDone ? 'Yangi' : 'Bajarildi';
      
      // Optimistic update
      st.done = !isCurrentlyDone;
      st.status = newStatus;
      
      api.post('/update-subtask/' + st.id, { status: newStatus }).then(res => {
        this.$emit('task-updated'); 
      }).catch(err => {
        console.error("Subtask holatini o'zgartirishda xatolik", err);
        // Revert on error
        st.done = isCurrentlyDone;
        st.status = isCurrentlyDone ? 'Bajarildi' : 'Yangi';
      });

      this.a11yMessage = st.done ? `Subtask "${st.name}" marked done` : `Subtask "${st.name}" marked not done`;
    },

    membersLabel(members) {
      return members.map(m => m.firstname + ' ' + m.lastname + '(' + m.tabel + ') - ' + m.process).join(', ');
    },

    // Avatar fayl nomi bo‘yicha olinadi; bo‘lmasa employees ro‘yxatidan id orqali qidiramiz
    contributorAvatar(c) {
      if (c?.avatar) {
        return `https://api.task-board.uz/storage/user/avatar/${c.avatar}`;
      }
      return this.getEmployeeAvatar(c?.user_id) ||
        'https://api.task-board.uz/storage/user/avatar/user.png';
    },

    // Avatar yuklanmasa — standart rasmga qaytamiz
    handleAvatarError(event) {
      const fallback = 'https://api.task-board.uz/storage/user/avatar/user.png';
      const img = event?.target?.tagName === 'IMG' ? event.target : event?.target?.querySelector?.('img');
      if (img && img.src !== fallback) {
        img.src = fallback;
      }
    },

    roleClass(role) {
      switch (role) {
        case 'Ijro':
          return 'role-ijro';
        case 'Rozilik':
          return 'role-rozilik';
        case 'Malumot':
          return 'role-malumot';
        case 'Test':
          return 'role-test';
        default:
          return 'role-default';
      }
    },

    scrollActivityToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.activityList;
        if (el) {
          el.scrollTo({
            top: el.scrollHeight,
            behavior: "smooth",
          });
        }
      });
    },
    formatDate(date) {
      if (!date) return '—'
      const d = new Date(date)
      return d.toLocaleDateString('en-GB')
    },
    formatDateTime(date) {
      if (!date) return '—'
      const d = new Date(date)
      return d.toLocaleString('en-GB')
    },

    redirectToEmployee(id) {
      this.$emit('redirect', id)
    },
    updateTaskColumn(id, column_id) {
      this.$emit('update-column', { id, column_id })
    },
    copyTask() {
      this.$emit('copy-task', this.task)
    },
    editTask(task) {
      this.$emit('edit-task', task)
    },
    deleteTask(id) {
      this.$emit('delete-task', id)
    },
    getHelp() {
      this.$emit('get-help', this.task.id)
    },

    // ===== COMMENT FORM LOGIC =====

    async sendComment(taskId) {
      if (!this.commentMessage && this.commentFiles.length === 0) return
      // Enter tez bir necha marta bosilsa — takroriy yuborishni to'xtatamiz
      if (this.isSendingComment) return
      this.isSendingComment = true

      try {
        let formData = new FormData();
        formData.append("task_id", taskId);
        if (this.commentMessage) {
          formData.append("message", this.commentMessage);
        }
        if (this.commentFiles && this.commentFiles.length > 0) {
          this.commentFiles.forEach((f) => {
            formData.append("files[]", f.file);
          });
        }

        const res = await api.post("/task-comment-create", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          meta: { al: false }
        });

        if (res.data.success) {
          if (!this.localComments.some(c => c.id === res.data.comment.id)) {
            this.localComments.push(res.data.comment);
            this.scrollActivityToBottom();
            this.$emit('comment-added', taskId);
          }
          
          this.commentMessage = '';
          this.removeAllFiles();
        }
      } catch (e) {
        console.error("Comment yuborishda xato:", e);
      } finally {
        this.isSendingComment = false
      }
    },

    // ==== Activity xabari: kontekst menyu + tahrirlash/o'chirish ====
    openMsgMenu(event, item) {
      // Faqat o'z xabari uchun tahrirlash/o'chirish mumkin
      if (!item || !item.isMine) return;
      event.preventDefault();
      const menuW = 172;
      const menuH = 96;
      let x = event.clientX;
      let y = event.clientY;
      if (x + menuW > window.innerWidth) x = window.innerWidth - menuW - 8;
      if (y + menuH > window.innerHeight) y = window.innerHeight - menuH - 8;
      this.msgMenu = { show: true, x, y, item };
    },
    closeMsgMenu() {
      this.msgMenu = { show: false, x: 0, y: 0, item: null };
    },
    startEditComment(item) {
      if (!item) return;
      this.editingCommentId = item.id;
      this.editingText = item.text || '';
      this.closeMsgMenu();
      this.$nextTick(() => {
        const ref = this.$refs.editInput;
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (el) {
          el.focus();
          try { el.setSelectionRange(el.value.length, el.value.length); } catch (e) { /* */ }
        }
      });
    },
    cancelEditComment() {
      this.editingCommentId = null;
      this.editingText = '';
    },
    async saveEditComment(item) {
      const text = this.editingText.trim();
      if (!text) return;
      if (text === (item.text || '')) {
        this.cancelEditComment();
        return;
      }
      if (this.isSavingEdit) return;
      this.isSavingEdit = true;
      try {
        await api.post(
          '/task-comment-update',
          { comment_id: item.id, message: text },
          { meta: { al: false } }
        );
        const c = this.localComments.find((x) => x.id === item.id);
        if (c) {
          c.message = text;
          c.edited = true;
        }
        this.editingCommentId = null;
        this.editingText = '';
        this.$emit('comment-updated', this.task.id);
      } catch (e) {
        console.error('Izohni tahrirlashda xato:', e);
        Swal.fire({
          icon: 'error',
          title: 'Xato',
          text: "Izohni tahrirlab bo'lmadi",
          customClass: { container: 'swal-z-top' },
        });
      } finally {
        this.isSavingEdit = false;
      }
    },
    async deleteComment(item) {
      this.closeMsgMenu();
      if (!item) return;
      const res = await Swal.fire({
        title: "O'chirish",
        text: "Ushbu izohni o'chirmoqchimisiz?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: "Ha, o'chirilsin",
        cancelButtonText: 'Bekor qilish',
        confirmButtonColor: '#ef4444',
        customClass: { container: 'swal-z-top' },
      });
      if (!res.isConfirmed) return;

      const idx = this.localComments.findIndex((x) => x.id === item.id);
      const backup = idx !== -1 ? this.localComments[idx] : null;
      if (idx !== -1) this.localComments.splice(idx, 1); // optimistik
      if (this.editingCommentId === item.id) this.cancelEditComment();

      try {
        await api.post(
          '/task-comment-delete',
          { comment_id: item.id },
          { meta: { al: false } }
        );
        this.$emit('comment-deleted', this.task.id);
      } catch (e) {
        console.error("Izohni o'chirishda xato:", e);
        if (backup && idx !== -1) this.localComments.splice(idx, 0, backup); // qaytaramiz
        Swal.fire({
          icon: 'error',
          title: 'Xato',
          text: "Izohni o'chirib bo'lmadi",
          customClass: { container: 'swal-z-top' },
        });
      }
    },

    commentFileUpload(event) {
      const files = event.target.files
      if (!files || files.length === 0) return

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const ext = file.name.split('.').pop().toLowerCase()
        const url = URL.createObjectURL(file)
        
        this.commentFiles.push({
          file: file,
          name: file.name,
          url: url,
          ext: ext
        })
      }
      
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },

    handlePaste(e) {
      const items = e.clipboardData?.items
      if (!items) return

      let hasFile = false
      for (const item of items) {
        if (item.kind === 'file') {
          const blob = item.getAsFile()
          if (!blob) continue

          hasFile = true
          // Chrome often sets the name of a pasted image to 'image.png'.
          // To ensure uniqueness and correct File handling:
          const fileName = blob.name === 'image.png' || !blob.name ? `pasted_image_${Date.now()}_${Math.floor(Math.random() * 1000)}.png` : blob.name;
          const file = new File([blob], fileName, { type: blob.type })

          const url = URL.createObjectURL(file)
          this.commentFiles.push({
            file: file,
            name: fileName,
            url: url,
            ext: fileName.split('.').pop().toLowerCase()
          })
        }
      }
      
      if (hasFile) {
        // Prevent default text paste behavior if files were pasted
        // (though usually browsers don't paste images into text inputs anyway)
      }
    },

    removeFile(index) {
      const f = this.commentFiles[index]
      if (f && f.url) {
        URL.revokeObjectURL(f.url)
      }
      this.commentFiles.splice(index, 1)
    },
    
    removeAllFiles() {
      this.commentFiles.forEach(f => {
        if (f.url) URL.revokeObjectURL(f.url)
      })
      this.commentFiles = []
      this.pdfUrl = ''
      this.pdfFileName = ''
      this.showPdfModal = false
      this.showImageModal = false
      this.zoomImageUrl = ''

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },

    closePdfModal() {
      this.showPdfModal = false
    },

    zoomIn() {
      this.zoomLevel = Math.min(this.zoomLevel + 0.2, 3)
    },

    zoomOut() {
      this.zoomLevel = Math.max(this.zoomLevel - 0.2, 0.4)
    },
    
    rotateImage() {
      this.rotationAngle += 90;
    },
    
    handleImageWheel(e) {
      if (e.ctrlKey || e.metaKey) {
        if (e.deltaY < 0) {
          this.zoomIn();
        } else {
          this.zoomOut();
        }
      }
    },

    isImage(nameOrPath) {
      if (!nameOrPath || typeof nameOrPath !== 'string') return false
      return /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(nameOrPath)
    },
    isPdf(nameOrPath) {
      if (!nameOrPath || typeof nameOrPath !== 'string') return false
      return nameOrPath.split('.').pop().toLowerCase() === 'pdf'
    },
    openPdf(fileObj) {
      if (this.isPdf(fileObj.name)) {
         this.pdfUrl = fileObj.url
         this.pdfFileName = fileObj.name
         this.showPdfModal = true
      }
    },
    openImageZoom(fileObj) {
      this.zoomImageUrl = fileObj.url
      this.zoomFileObj = fileObj
      this.zoomLevel = 1
      this.rotationAngle = 0
      this.showImageModal = true
    },
    
    handleFileClick(fileObj) {
      if (this.isImage(fileObj.name)) {
        this.openImageZoom(fileObj)
      } else {
        this.forceDownload(fileObj.url, fileObj.name || 'download')
      }
    },

    async forceDownload(url, filename) {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      } catch (error) {
        console.error('Download failed:', error);
        // Fallback
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  },
}
</script>

<style>
.v-overlay-container .v-overlay:has(.highest-z-index) {
  z-index: 100000 !important;
}
.highest-z-index {
  z-index: 100000 !important;
}
</style>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined');

.editable-pill {
  cursor: pointer;
  transition: all 0.2s ease;
}
.editable-pill:hover {
  opacity: 0.8;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transform: translateY(-1px);
}

/* Custom Modal for Deadline */
.custom-modal-content {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
}
.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}
.custom-modal-header h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}
.custom-modal-header .close-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.2s;
}
.custom-modal-header .close-btn:hover {
  background: #f1f5f9;
  color: #334155;
}
.custom-modal-body {
  padding: 20px;
}
.custom-input-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 8px;
}
.custom-date-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.custom-date-input-wrapper .date-icon {
  position: absolute;
  left: 12px;
  color: #64748b;
  font-size: 14px;
  pointer-events: none;
}
.custom-date-input {
  width: 100%;
  padding: 10px 12px 10px 36px;
  font-size: 13px;
  color: #334155;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  outline: none;
  transition: all 0.2s;
  background: #f8fafc;
}
.custom-date-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.custom-date-input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
  transition: 0.2s;
}
.custom-date-input::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}
.custom-modal-footer {
  padding: 14px 20px;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #f1f5f9;
}
.custom-btn-cancel {
  background: transparent;
  border: 1px solid #cbd5e1;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}
.custom-btn-cancel:hover {
  background: #f1f5f9;
  color: #1e293b;
}
.custom-btn-save {
  background: #3b82f6;
  border: none;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
}
.custom-btn-save:hover {
  background: #2563eb;
}
.custom-btn-save:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp { from { opacity: 0; transform: translateY(10px) scale(0.98); } to { opacity: 1; transform: translateY(0) scale(1); } }
/* =====================
   POPUP ACTION MENU
===================== */

.popup {
  --burger-line-width: 1.125em;
  --burger-line-height: 0.125em;
  --burger-offset: 0.625em;
  --burger-bg: rgba(0, 0, 0, 0.15);
  --burger-color: #333;
  --burger-line-border-radius: 0.1875em;
  --burger-diameter: 2.125em;
  --burger-btn-border-radius: calc(var(--burger-diameter) / 2);
  --burger-line-transition: 0.3s;
  --burger-transition: all 0.1s ease-in-out;
  --burger-hover-scale: 1.1;
  --burger-active-scale: 0.95;
  --burger-enable-outline-color: var(--burger-bg);
  --burger-enable-outline-width: 0.125em;
  --burger-enable-outline-offset: var(--burger-enable-outline-width);
  /* nav */
  --nav-padding-x: 0.25em;
  --nav-padding-y: 0.625em;
  --nav-border-radius: 0.375em;
  --nav-border-color: #ccc;
  --nav-border-width: 0.0625em;
  --nav-shadow-color: rgba(0, 0, 0, 0.2);
  --nav-shadow-width: 0 1px 5px;
  --nav-bg: #eee;
  --nav-font-family: Menlo, Roboto Mono, monospace;
  --nav-default-scale: 0.8;
  --nav-active-scale: 1;
  --nav-position-left: 0;
  --nav-position-right: unset;
  /* if you want to change sides just switch one property */
  /* from properties to "unset" and the other to 0 */
  /* title */
  --nav-title-size: 0.625em;
  --nav-title-color: #777;
  --nav-title-padding-x: 1rem;
  --nav-title-padding-y: 0.25em;
  /* nav button */
  --nav-button-padding-x: 1rem;
  --nav-button-padding-y: 0.375em;
  --nav-button-border-radius: 0.375em;
  --nav-button-font-size: 12px;
  --nav-button-hover-bg: #6495ed;
  --nav-button-hover-text-color: #fff;
  --nav-button-distance: 0.875em;
  /* underline */
  --underline-border-width: 0.0625em;
  --underline-border-color: #ccc;
  --underline-margin-y: 0.3125em;
}

/* popup settings 👆 */

.popup {
  display: inline-block;
  text-rendering: optimizeLegibility;
  position: relative;
  z-index: 1;
  margin: 0;
  user-select: none;
  /* pointer-events: none; */
}

.popup input {
  display: none;
}

.burger {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background: var(--burger-bg);
  width: var(--burger-diameter);
  height: var(--burger-diameter);
  border-radius: var(--burger-btn-border-radius);
  border: none;
  cursor: pointer;
  overflow: hidden;
  transition: var(--burger-transition);
  outline: var(--burger-enable-outline-width) solid transparent;
  outline-offset: 0;
}

.burger span {
  height: var(--burger-line-height);
  width: var(--burger-line-width);
  background: var(--burger-color);
  border-radius: var(--burger-line-border-radius);
  position: absolute;
  transition: var(--burger-line-transition);
}

[data-bs-theme="dark"] .burger span {
  background-color: white !important;
}

.burger span:nth-child(1) {
  top: var(--burger-offset);
}

.burger span:nth-child(2) {
  bottom: var(--burger-offset);
}

.burger span:nth-child(3) {
  top: 50%;
  transform: translateY(-50%);
}

.popup-window {
  transform: scale(var(--nav-default-scale));
  visibility: hidden;
  opacity: 0;
  position: absolute;
  padding: var(--nav-padding-y) var(--nav-padding-x);
  background: var(--nav-bg);
  font-family: var(--nav-font-family);
  color: var(--nav-text-color);
  border-radius: var(--nav-border-radius);
  box-shadow: var(--nav-shadow-width) var(--nav-shadow-color);
  border: var(--nav-border-width) solid var(--nav-border-color);
  top: calc(var(--burger-diameter) + var(--burger-enable-outline-width) + var(--burger-enable-outline-offset));
  right: 0;      /* <-- chapga ochiladi (burgerning o‘ng chetiga yopishadi) */
  left: auto;    /* <-- shart! */
  width: max-content;   /* xohlasangiz */
  z-index: 9999;
  transform-origin: top right; /* animatsiya ham to‘g‘ri bo‘ladi */
  transition: var(--burger-transition);
}


.popup-window legend {
  padding: var(--nav-title-padding-y) var(--nav-title-padding-x);
  margin: 0;
  color: var(--nav-title-color);
  font-size: var(--nav-title-size);
  text-transform: uppercase;
}

.popup-window ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.popup-window ul li:hover .hover-color {
  color: white!important;
}

.popup-window ul button {
  outline: none;
  width: 100%;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  color: var(--burger-color);
  font-size: var(--nav-button-font-size);
  padding: var(--nav-button-padding-y) var(--nav-button-padding-x);
  white-space: nowrap;
  border-radius: var(--nav-button-border-radius);
  cursor: pointer;
  column-gap: var(--nav-button-distance);
}

.popup-window ul li:nth-child(1) svg,
.popup-window ul li:nth-child(2) svg {
  color: cornflowerblue;
}

.popup-window ul li:nth-child(4) svg,
.popup-window ul li:nth-child(5) svg {
  color: rgb(153, 153, 153);
}

.popup-window ul li:nth-child(7) svg {
  color: red;
}

.popup-window hr {
  margin: var(--underline-margin-y) 0;
  border: none;
  border-bottom: var(--underline-border-width) solid var(--underline-border-color);
}

/* actions */

.popup-window ul button:hover,
.popup-window ul button:focus-visible,
.popup-window ul button:hover svg,
.popup-window ul button:focus-visible svg {
  color: var(--nav-button-hover-text-color);
  background: var(--nav-button-hover-bg);
}

.burger:hover {
  transform: scale(var(--burger-hover-scale));
}

.burger:active {
  transform: scale(var(--burger-active-scale));
}

.burger:focus:not(:hover) {
  outline-color: var(--burger-enable-outline-color);
  outline-offset: var(--burger-enable-outline-offset);
}

.popup input:checked+.burger span:nth-child(1) {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
}

.popup input:checked+.burger span:nth-child(2) {
  bottom: 50%;
  transform: translateY(50%) rotate(-45deg);
}

.popup input:checked+.burger span:nth-child(3) {
  transform: translateX(calc(var(--burger-diameter) * -1 - var(--burger-line-width)));
}

.popup input:checked~nav {
  transform: scale(var(--nav-active-scale));
  visibility: visible;
  opacity: 1;
}

/* =====================
   SHELL + RESPONSIVE
===================== */

.task-dialog-shell {
  --task-page-bg: #f3f3f9;
  --task-surface-bg: #ffffff;
  --task-surface-alt-bg: #f9fafc;
  --task-border-color: #e9ebec;
  --task-text-main: #2c2c3a;
  --task-text-muted: #7a7a8c;
  --task-toolbar-bg: #f3f3f9;
  --task-toolbar-icon: #6c6c80;
  --task-accent: #405189;
  --task-accent-soft: rgba(64, 81, 137, 0.12);

  position: relative;
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'SF Pro Text',
    'Segoe UI',
    sans-serif;
  color: var(--task-text-main);
  width: 100%;
  max-width: 1440px;
  border-radius: 12px;
  padding: 16px;
  background: var(--task-page-bg);
  margin: 0 auto;
}

/* DARK MODE */
:root[data-bs-theme='dark'] .task-dialog-shell {
  --task-page-bg: radial-gradient(circle at top left, #191932 0, #050509 55%);
  --task-surface-bg: #111118;
  --task-surface-alt-bg: #161620;
  --task-border-color: #252535;
  --task-text-main: #f6f6fb;
  --task-text-muted: #a0a0b8;
  --task-toolbar-bg: #1b1b25;
  --task-toolbar-icon: #c1c1d3;
  --task-accent: #7c5cff;
  --task-accent-soft: rgba(124, 92, 255, 0.12);
}

/* MODERN FILE ATTACHMENTS (TaskDialog) */
.task-attachments-section {
  padding: 12px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 20px;
}
.attachment-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  list-style: none;
  user-select: none;
}
.attachment-section-title::-webkit-details-marker {
  display: none;
}
.summary-chevron {
  transition: transform 0.3s ease;
  color: #94a3b8;
}
details[open] .summary-chevron {
  transform: rotate(180deg);
}
.task-files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}
.task-file-chip-modern {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);
}
.task-file-chip-modern:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59,130,246,0.1);
  transform: translateY(-2px);
}
.task-file-chip-modern .file-icon-bg {
  width: 36px;
  height: 36px;
  background: #eff6ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
  margin-right: 12px;
}
.task-file-chip-modern .file-chip-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;
}
.task-file-chip-modern .file-chip-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}
.task-file-chip-modern .file-chip-meta {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}
.task-file-chip-modern .download-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f8fafc;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-left: 8px;
  transition: all 0.2s;
}
.task-file-chip-modern:hover .download-btn {
  background: #eff6ff;
  color: #3b82f6;
}

:root[data-bs-theme='dark'] .task-attachments-section {
  background: #0f172a;
  border-color: #1e293b;
}
:root[data-bs-theme='dark'] .attachment-section-title {
  color: #f1f5f9;
}
:root[data-bs-theme='dark'] .task-file-chip-modern {
  background: #1e293b;
  border-color: #334155;
}
:root[data-bs-theme='dark'] .task-file-chip-modern:hover {
  border-color: #3b82f6;
}
:root[data-bs-theme='dark'] .task-file-chip-modern .file-icon-bg {
  background: #1e293b;
  box-shadow: inset 0 0 0 1px #334155;
}
:root[data-bs-theme='dark'] .task-file-chip-modern .file-chip-name {
  color: #f1f5f9;
}
:root[data-bs-theme='dark'] .task-file-chip-modern .download-btn {
  background: #0f172a;
  color: #64748b;
}
:root[data-bs-theme='dark'] .task-file-chip-modern:hover .download-btn {
  background: #3b82f6;
  color: #ffffff;
}

/* Floating close X button */
.dialog-close-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: rgba(255, 255, 255, 0.9);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
  font-size: 15px;
  line-height: 1;
  padding: 0;
}

:root[data-bs-theme='dark'] .dialog-close-btn {
  background: rgba(10, 10, 20, 0.95);
  border-color: rgba(255, 255, 255, 0.18);
  color: #f5f5ff;
}

.dialog-close-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(15, 34, 58, 0.25);
}

/* PAGE SHELL */

.page-shell {
  width: 100%;
  background: var(--task-surface-bg);
  border-radius: 10px;
  border: 1px solid var(--task-border-color);
  display: flex;
  overflow: hidden;
  box-shadow: 0 18px 45px rgba(15, 34, 58, 0.15);
}

/* LEFT SIDE – main content */
.task-main {
  height: 90vh;
  flex: 1 1 auto;
  /* flex item'ning default min-width:auto uzun matn tufayli kengayib ketishiga yo‘l qo‘yadi */
  min-width: 0;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  color: var(--task-text-main);
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #adb5bd transparent;

}

/* RIGHT SIDE – activity panel */
.activity-panel {
  height: 90vh;
  width: 350px;
  /* qisilib ketmasligi uchun */
  flex: 0 0 350px;
  border-left: 1px solid var(--task-border-color);
  background: var(--task-surface-alt-bg);
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #adb5bd transparent;
}

/* =====================
   ACTIVITY PANEL
===================== */

.activity-header {
  padding: 14px 16px;
  border-bottom: 1px solid var(--task-border-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: var(--task-text-muted);
}

.activity-list {
  height: 100%;
  padding: 10px;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #adb5bd transparent;
}

.activity-empty {
  font-size: 12px;
  color: var(--task-text-muted);
  padding: 4px 0;
}

.activity-unread-divider {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  margin: 8px 0;
  padding: 4px 0;
  border-top: 1px dashed #bbb;
  color: #666;
}

/* Telegram-style Chat Messages */
.chat-message-wrapper {
  display: flex;
  margin-bottom: 8px;
  width: 100%;
}

.chat-other {
  justify-content: flex-start;
  padding-right: 20%;
}

.chat-mine {
  justify-content: flex-end;
  padding-left: 20%;
}

.chat-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
  align-self: flex-end;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.chat-bubble {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 14px;
  position: relative;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  min-width: 80px;
}

.chat-other .chat-bubble {
  background: #ffffff;
  border: 1px solid #eef2f6;
  border-bottom-left-radius: 4px;
}

.chat-mine .chat-bubble {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.2);
  border-bottom-right-radius: 4px;
}
.chat-mine .chat-text {
  color: #ffffff;
}
.chat-mine .chat-time {
  color: rgba(255, 255, 255, 0.8);
}
.chat-mine .chat-file-name {
  color: #ffffff;
}
.chat-mine .chat-file-meta {
  color: rgba(255, 255, 255, 0.8);
}

:root[data-bs-theme='dark'] .chat-other .chat-bubble {
  background: #1e293b;
  border-color: #334155;
}

:root[data-bs-theme='dark'] .chat-mine .chat-bubble {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border: none;
}

.chat-author {
  font-weight: 600;
  font-size: 12px;
  color: var(--task-accent);
}

.chat-text {
  font-size: 14px;
  color: var(--task-text-main);
  line-height: 1.4;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.chat-time {
  font-size: 10px;
  color: #94a3b8;
  align-self: flex-end;
  display: flex;
  align-items: center;
}
.chat-edited-tag {
  margin-left: 4px;
  font-style: italic;
  opacity: 0.8;
}

/* O'z xabari ustida o'ng tugma bosilganda ta'kidlash */
.chat-menu-active .chat-bubble {
  box-shadow: 0 0 0 2px var(--task-accent, #6366f1);
}

/* Inline tahrirlash */
.chat-edit {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
}
.chat-edit-input {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 13.5px;
  font-family: inherit;
  line-height: 1.4;
  color: #1e293b;
  background: #fff;
  resize: vertical;
  outline: none;
}
.chat-edit-input:focus {
  border-color: var(--task-accent, #6366f1);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.chat-edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}
.chat-edit-btn {
  border: none;
  border-radius: 7px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.chat-edit-btn.cancel {
  background: #f1f5f9;
  color: #64748b;
}
.chat-edit-btn.cancel:hover {
  background: #e2e8f0;
}
.chat-edit-btn.save {
  background: var(--task-accent, #6366f1);
  color: #fff;
}
.chat-edit-btn.save:hover {
  filter: brightness(1.05);
}
.chat-edit-btn.save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Kontekst menyu (o'ng tugma) */
.msg-menu-backdrop {
  position: fixed;
  inset: 0;
  z-index: 3000;
}
.msg-context-menu {
  position: fixed;
  z-index: 3001;
  min-width: 160px;
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
  padding: 5px;
  animation: msg-menu-in 0.12s ease;
}
@keyframes msg-menu-in {
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
}
.msg-menu-item {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  border: none;
  background: transparent;
  padding: 8px 11px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: background 0.14s ease;
}
.msg-menu-item i {
  font-size: 12px;
  width: 14px;
  text-align: center;
  color: #94a3b8;
}
.msg-menu-item:hover {
  background: #f1f5f9;
}
.msg-menu-item.danger {
  color: #ef4444;
}
.msg-menu-item.danger i {
  color: #ef4444;
}
.msg-menu-item.danger:hover {
  background: rgba(239, 68, 68, 0.08);
}

.chat-files {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 6px;
}

.chat-file-item {
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.03);
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  border: 1px solid rgba(0,0,0,0.05);
}

.chat-file-item:hover {
  background: rgba(0,0,0,0.06);
}

:root[data-bs-theme='dark'] .chat-file-item {
  background: rgba(255,255,255,0.05);
  border-color: rgba(255,255,255,0.05);
}

.chat-file-thumb-wrapper {
  position: relative;
  width: 36px;
  height: 36px;
  margin-right: 10px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
}

.chat-file-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.chat-file-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s;
  text-decoration: none;
  border: none;
  outline: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}
.chat-file-overlay:hover {
  color: #fff;
}

.chat-file-item:hover .chat-file-overlay {
  opacity: 1;
}

.chat-file-icon {
  width: 36px;
  height: 36px;
  background: #e0e7ff;
  color: #4f46e5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 18px;
  flex-shrink: 0;
}

.chat-mine .chat-file-icon {
  background: var(--task-surface-bg);
  color: var(--task-accent);
}

.chat-file-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-file-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--task-text-main);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-file-meta {
  font-size: 10px;
  color: var(--task-text-muted);
  margin-top: 2px;
}

.activity-footer {
  padding: 10px 16px 14px;
  border-top: 1px solid var(--task-border-color);
}

.activity-input {
  width: 100%;
  border-radius: 999px;
  border: 1px solid var(--task-border-color);
  background: var(--task-surface-bg);
  padding: 8px 12px;
  font-size: 12px;
  color: var(--task-text-main);
  outline: none;
}

.activity-input::placeholder {
  color: var(--task-text-muted);
}

/* =====================
   HEADER / BREADCRUMB
===================== */

.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 20;
  font-size: 18px;
  vertical-align: middle;
}

.page-header {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--task-border-color);
  gap: 10px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--task-text-muted);
}
.breadcrumb > span {
  display: inline-flex;
  align-items: center;
}
.breadcrumb .crumb-sep {
  opacity: 0.6;
}

.task-type-pill {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid var(--task-border-color);
  font-size: 11px;
  color: var(--task-text-muted);
  background: var(--task-surface-alt-bg);
}

/* TITLE */

.task-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 6px;
}

.task-title-row h1 {
  font-size: 22px;
  font-weight: 600;
  margin: 4px 0 2px;
  color: var(--task-text-main);
}

/* Breadcrumbdagi topshiriq raqami — ko'zga tashlanadigan badge */
.breadcrumb .crumb-number {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  vertical-align: middle;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
  color: #fff;
  background: linear-gradient(135deg, var(--task-accent, #6366f1), #8b5cf6);
  padding: 2px 10px 2px 7px;
  border-radius: 20px;
  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.3);
  font-variant-numeric: tabular-nums;
}
.breadcrumb .crumb-number i {
  font-size: 9px;
  opacity: 0.85;
}

.task-title-row .hint {
  font-size: 12px;
  color: var(--task-text-muted);
}

.title-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

/* BUTTONS */

.icon-btn {
  border-radius: 999px;
  border: 1px solid var(--task-border-color);
  background: var(--task-accent-soft);
  padding: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 11px;
  color: var(--task-accent);
}

.icon-btn-ghost {
  background: transparent;
  color: var(--task-text-muted);
}

.icon-btn .material-symbols-outlined {
  font-size: 16px;
}

/* =====================
   META GRID
===================== */

.meta-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 16px;
  margin-top: 10px;
}

.meta-field {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 12px;
}

.meta-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--task-surface-alt-bg);
  color: var(--task-text-muted);
  flex-shrink: 0;
}

.meta-label {
  color: var(--task-text-muted);
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.meta-value {
  color: var(--task-text-main);
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

/* Status pill (semantic colors) */

.status-pill {
  padding: 4px 11px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.status-pill--done {
  background: #2ecc71;
}

.status-pill--progress {
  background: #3498db;
}

.status-pill--review {
  background: #f1c40f;
  color: #000;
}

.status-pill--rejected {
  background: #e74c3c;
}

.status-pill--jarayonda {
  background: #fee2e2;
  color: #ef4444;
}

.status-pill--bajarildi {
  background: #d1fae5;
  color: #059669;
}

/* Dates pills */

.pill {
  border-radius: 999px;
  padding: 3px 9px;
  font-size: 11px;
  background: var(--task-surface-alt-bg);
  border: 1px solid var(--task-border-color);
  color: var(--task-text-main);
}

.pill-created {
  color: #7f8c8d;
}

.pill-deadline {
  border-color: rgba(231, 76, 60, 0.35);
  background: rgba(231, 76, 60, 0.07);
  color: #e74c3c;
  font-weight: 600;
}

/* Assignees pill */

.assignee-pill {
  background: #dfe6fd;
  color: #2c3e50;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

:root[data-bs-theme='dark'] .assignee-pill {
  background: #26263a;
  color: #ecf0f1;
}

.assignee-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2ecc71;
}

/* Priority pill */

.priority-pill {
  padding: 3px 11px;
  border-radius: 999px;
  font-size: 11px;
  color: #fff;
  font-weight: 600;
}

.priority-pill--high {
  background: #e74c3c;
}

.priority-pill--medium {
  background: #f39c12;
  color: #000;
}

.priority-pill--low {
  background: #3498db;
}

/* Comments / unread / check */

.pill-comments {
  background: rgba(52, 152, 219, 0.08);
  border-color: rgba(52, 152, 219, 0.35);
  color: #2980b9;
}

.pill-unread {
  background: rgba(231, 76, 60, 0.1);
  border-color: rgba(231, 76, 60, 0.45);
  color: #c0392b;
}

.pill-check {
  background: rgba(149, 165, 166, 0.1);
  border-color: rgba(149, 165, 166, 0.4);
  color: #7f8c8d;
}

.pill-check--done {
  background: rgba(46, 204, 113, 0.15);
  border-color: rgba(46, 204, 113, 0.5);
  color: #2ecc71;
}

/* =====================
   BODY GRID
===================== */

.body-grid {
  display: grid;
  grid-template-columns: minmax(0, 3fr);
  gap: 5px;
  margin-top: 10px;
}

/* =====================
   CONTRIBUTORS
===================== */
.contributors-card {
  padding-bottom: 10px;
}

.contributors-head-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contributor-stack {
  display: flex;
  align-items: center;
}

.contributor-stack-img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--task-surface-bg);
  background: var(--task-surface-alt-bg);
  position: relative;
}

.contributor-stack-more {
  margin-left: -10px;
  min-width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--task-surface-bg);
  background: var(--task-accent-soft);
  color: var(--task-accent);
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.contributors-body {
  margin-top: 10px;
}

.contributors-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 8px;
}

.contributor-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid var(--task-border-color);
  border-radius: 10px;
  background: var(--task-surface-alt-bg);
  min-width: 0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.contributor-row:hover {
  border-color: var(--task-accent);
  box-shadow: 0 2px 8px rgba(15, 34, 58, 0.08);
}

.contributor-row.is-me {
  background: var(--task-accent-soft);
  border-color: var(--task-accent);
}

.contributor-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: var(--task-surface-bg);
}

.contributor-info {
  flex: 1 1 auto;
  min-width: 0;
}

.contributor-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--task-text-main);
  line-height: 1.3;
}

.contributor-me-tag {
  margin-left: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--task-accent);
}

.contributor-roles {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 3px;
}

.contributor-role {
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 4px;
  background: rgba(120, 120, 140, 0.12);
  color: var(--task-text-muted);
  white-space: nowrap;
}

.role-creator {
  background: rgba(64, 81, 137, 0.14);
  color: #405189;
}
.role-ijro {
  background: rgba(16, 185, 129, 0.14);
  color: #0f9d76;
}
.role-rozilik {
  background: rgba(245, 158, 11, 0.16);
  color: #b57209;
}
.role-malumot {
  background: rgba(100, 116, 139, 0.14);
  color: #64748b;
}
.role-test {
  background: rgba(139, 92, 246, 0.14);
  color: #7c5cff;
}

.contributor-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.contributor-stat {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 600;
  color: var(--task-text-muted);
}

.contributor-stat .material-symbols-outlined {
  font-size: 14px;
}

.contributor-stat--idle {
  opacity: 0.45;
}

.contributors-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 18px 0;
  font-size: 12px;
  color: var(--task-text-muted);
}

.section-card {
  margin: 0 0 20px;
  background: var(--task-surface-bg);
  border-radius: 12px;
  border: 1px solid var(--task-border-color);
  padding: 14px 14px 12px;
  transition: all 0.25s ease;
}

.section-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.10);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-header h2 {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--task-text-muted);
  margin: 0;
}

.section-header .section-hint {
  font-size: 11px;
  color: var(--task-text-muted);
}

/* PRIMEVUE EDITOR */

.description-editor--prime {
  /* qat'iy height o‘rniga — matnga qarab o‘sadi, chegaradan keyin scroll */
  max-height: 340px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--task-border-color);
  background: var(--task-surface-bg);
  display: flex;
  flex-direction: column;
  min-width: 0;
}

:deep(.p-editor) {
  border: none !important;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

:deep(.p-editor-toolbar) {
  background: var(--task-toolbar-bg) !important;
  border: none !important;
  border-bottom: 1px solid var(--task-border-color) !important;
  padding: 4px 8px;
}

:deep(.p-editor-toolbar .ql-stroke) {
  stroke: var(--task-toolbar-icon) !important;
}
:deep(.p-editor-toolbar .ql-fill) {
  fill: var(--task-toolbar-icon) !important;
}
:deep(.p-editor-toolbar .ql-picker-label) {
  color: var(--task-toolbar-icon) !important;
}

:deep(.p-editor-toolbar .ql-active .ql-stroke),
:deep(.p-editor-toolbar .ql-active .ql-fill),
:deep(.p-editor-toolbar .ql-picker-label.ql-active) {
  stroke: var(--task-accent) !important;
  fill: var(--task-accent) !important;
  color: var(--task-accent) !important;
}

:deep(.p-editor-content) {
  background: var(--task-surface-bg);
  color: var(--task-text-main);
  min-height: 90px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

:deep(.p-editor-content .ql-editor) {
  min-height: 80px;
  max-height: 260px;
  overflow-y: auto;
  padding: 10px 12px;
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--task-text-main);
  /* uzun path/URL'lar qatorni cho‘zib yubormasligi uchun */
  overflow-wrap: break-word;
  word-break: break-word;
  scrollbar-width: thin;
  scrollbar-color: #adb5bd transparent;
}

/* Compact tipografiya — desc ichidagi bloklar orasidagi bo‘shliqni kamaytiramiz */
:deep(.p-editor-content .ql-editor p) {
  margin-bottom: 4px;
}

:deep(.p-editor-content .ql-editor p:last-child) {
  margin-bottom: 0;
}

:deep(.p-editor-content .ql-editor ul),
:deep(.p-editor-content .ql-editor ol) {
  margin: 4px 0;
  padding-left: 18px;
}

:deep(.p-editor-content .ql-editor li) {
  margin-bottom: 2px;
}

:deep(.p-editor-content .ql-editor h1) { font-size: 18px; margin: 8px 0 4px; }
:deep(.p-editor-content .ql-editor h2) { font-size: 16px; margin: 8px 0 4px; }
:deep(.p-editor-content .ql-editor h3) { font-size: 14.5px; margin: 6px 0 4px; }

:deep(.p-editor-content .ql-editor pre),
:deep(.p-editor-content .ql-editor code) {
  font-size: 12.5px;
}

/* ATTACHMENT */

.attachment-row {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.attachment-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--task-text-muted);
}

.attachment-link {
  color: var(--task-accent);
  text-decoration: underline;
  cursor: pointer;
}

/* CUSTOM FIELDS */

.custom-fields-list {
  margin-top: 6px;
  border-top: 1px solid var(--task-border-color);
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cf-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 7px 8px;
  border-radius: 8px;
  background: var(--task-surface-alt-bg);
}

.cf-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--task-text-main);
}

.cf-placeholder {
  font-size: 12px;
  color: var(--task-text-muted);
}

.cf-deadline {
  color: #e74c3c;
}

.cf-add-row {
  padding: 4px 2px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--task-text-muted);
}

.cf-add-row .material-symbols-outlined {
  font-size: 16px;
}

/* =====================
   RESPONSIVE
===================== */

@media (max-width: 1120px) {
  .page-shell {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .task-dialog-shell {
    padding: 10px;
    border-radius: 8px;
  }

  .page-shell {
    border-radius: 8px;
  }

  .meta-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .task-dialog-shell {
    padding: 8px;
    border-radius: 0;
  }

  .page-shell {
    border-radius: 0;
  }

  .meta-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .task-title-row {
    flex-direction: column;
    align-items: flex-start;
  }

}

.container-1 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 999px;
  border: 1px solid var(--task-border-color);
  background: var(--task-surface-bg);
}

.attach-label {
  cursor: pointer;
  font-size: 18px;
  margin: 0;
  color: var(--task-text-muted);
  display: flex;
  align-items: center;
}

.attach-label:hover {
  color: var(--task-accent);
}

.comment-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.comment-files-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.comment-file-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  padding: 6px 10px;
  background: var(--task-surface-bg);
  border: 1px solid var(--task-border-color);
  border-radius: 20px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  width: max-content;
  max-width: 100%;
}

.file-thumb {
  width: 28px;
  height: 28px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.file-icon-placeholder {
  width: 28px;
  height: 28px;
  background: #e0e7ff;
  color: #4f46e5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.file-name {
  font-size: 12px;
  font-weight: 500;
  color: var(--task-text-main);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.file-remove-btn {
  border: none;
  background: #fee2e2;
  color: #ef4444;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s;
  flex-shrink: 0;
}

.file-remove-btn:hover {
  background: #fecaca;
  color: #b91c1c;
}

.comment-input {
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
  font-size: 13px;
  padding: 0;
  color: var(--task-text-main);
}

.comment-input::placeholder {
  color: var(--task-text-muted);
}

.comment-send-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--task-accent);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* PDF modal */

.pdf-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.pdf-controls {
  position: absolute;
  top: 12px;
  right: 16px;
  display: flex;
  gap: 10px;
}

.pdf-controls a,
.pdf-controls button {
  border: none;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pdf-frame {
  width: 90%;
  height: 90%;
  border-radius: 8px;
  background: #ffffff;
}

/* Image modal */

.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modern-image-controls {
  position: absolute;
  top: 20px;
  right: 24px;
  display: flex;
  gap: 12px;
  background: rgba(25, 25, 25, 0.6);
  padding: 8px 14px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  align-items: center;
  z-index: 1051;
}

.modern-image-controls button,
.modern-image-controls .modern-download-btn {
  border: none;
  background: transparent;
  color: #e2e8f0;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s;
  text-decoration: none;
}

.modern-image-controls button:hover,
.modern-image-controls .modern-download-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.modern-image-controls .modern-close-btn {
  color: #fca5a5;
}

.modern-image-controls .modern-close-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.modern-image-controls .divider {
  width: 1px;
  height: 24px;
  background: rgba(255,255,255,0.2);
  margin: 0 4px;
}

.zoomable-image {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  transition: transform 0.25s cubic-bezier(0.2, 0, 0, 1);
  will-change: transform;
}

/* --- Subtasks card layout --- */
.subtasks-card {
  transition: all 0.25s ease;
  cursor: pointer;
}

.subtasks-card:hover {
  transform: translateY(-1px);
}

.subtasks-card .section-header-left{
  display:flex;
  align-items:baseline;
  gap:10px;
}

.subtasks-empty{
  display:flex;
  align-items:center;
  gap:10px;
  padding:12px;
  border:1px dashed var(--task-border-color);
  border-radius:10px;
  color: var(--task-text-muted);
  font-size: 13px;
}

.subtasks-list{
  list-style:none;
  margin: 0;
  padding: 0;
  display:flex;
  flex-direction:column;
  gap:8px;
}

.subtask-item{
  display:flex;
  gap:10px;
  padding:10px;
  border:1px solid var(--task-border-color);
  border-radius:10px;
  background: rgba(255,255,255,0.02);
  cursor: default;
  align-items: center;
}

.st-form-item {
  position: relative;
}

.st-form-item:hover .st-form-act {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
  pointer-events: auto;
}

.subtask-item.is-done{
  opacity: 0.75;
  border: 1px solid rgba(46, 204, 113, 0.5);
}

.subtask-check{
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--task-border-color);
  background: transparent;
  cursor: pointer;
  display:grid;
  place-items:center;
}

.subtask-check:focus-visible,
.icon-btn:focus-visible,
.btn:focus-visible,
.menu-item:focus-visible{
  outline: 2px solid rgba(100, 180, 255, 0.6);
  outline-offset: 2px;
}

.subtask-main{
  min-width: 0;
  flex: 1;
}

.subtask-top{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:10px;
}

.subtask-title{
  display:flex;
  align-items:center;
  gap:8px;
  min-width:0;
}

.subtask-name{
  font-size: 14px;
  font-weight: 600;
  color: var(--task-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 520px;
}

.chip{
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 999px;
  border: 1px solid var(--task-border-color);
  color: var(--task-text-muted);
}
.chip--new{
  letter-spacing: .06em;
}

.subtask-actions{
  position: relative;
  display:flex;
  align-items:center;
  gap:6px;
  flex-shrink:0;
}

.icon-btn{
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid var(--task-border-color);
  background: transparent;
  cursor: pointer;
  display:grid;
  place-items:center;
}

.subtask-meta{
  display:flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap:wrap;
  gap:8px;
  margin-top:6px;
}

.meta-chip{
  display:flex;
  align-items:center;
  gap:6px;
  font-size:12px;
  padding: 4px 8px;
  border: 1px solid var(--task-border-color);
  border-radius: 999px;
}

.subtask-desc{
  margin: 0;
  font-size: 12.5px;
  color: var(--task-text-muted);
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;   /* compact */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* --- Buttons --- */
.btn-c{
  border: 1px solid var(--task-border-color);
  background: transparent;
  color: var(--task-text);
  cursor: pointer;
  border-radius: 10px;
  display:flex;
  align-items:center;
  gap:6px;
}
.btn--sm{ padding: 6px 10px; font-size: 12px; }
.btn--ghost{ opacity: .95; }

.more-menu{
  position: relative;
}

.menu{
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 180px;
  background: var(--task-surface-bg);
  border: 1px solid var(--task-border-color);
  border-radius: 12px;
  padding: 6px;
  z-index: 10;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}

.menu-item{
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  color: var(--task-text);
  cursor: pointer;
  border-radius: 10px;
  padding: 8px 10px;
  display:flex;
  align-items:center;
  gap:8px;
  font-size: 13px;
}

.menu-item:hover{
  background: rgba(255,255,255,0.04);
}

.menu-item.danger{
  color: #ff6b6b;
}

/* screen-reader only */
.sr-only{
  position:absolute!important;
  width:1px!important;
  height:1px!important;
  padding:0!important;
  margin:-1px!important;
  overflow:hidden!important;
  clip:rect(0,0,0,0)!important;
  white-space:nowrap!important;
  border:0!important;
}

/* Header clickable */
.section-header--toggle {
  cursor: pointer;
  user-select: none;
  height: 30px;
}

/* Chevron icon */
.toggle-icon {
  font-size: 20px;
  transition: transform 0.2s ease;
  color: var(--task-text-muted);
}

.toggle-icon.open {
  transform: rotate(180deg);
}

/* Content wrapper */
.subtasks-content {
  position: relative;
  margin-top: 10px;
}

/* ===== Collapse animation ===== */
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.25s ease;
}

.collapse-enter-from,
.collapse-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}



.option-modal {
  position: fixed;
  /* width: 95%; */
  /* min-height: 200px; */
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 9999!important;
  margin-bottom: 25px;
  animation: fadeUp 0.2s ease;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.subtask-assignee-section {
  padding: 8px 12px;
  font-size: 14px;
}

.subtask-assignee-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.subtask-checkbox {
  margin: 0;
  transform: scale(0.9);
}

.subtask-assignee-form {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.subtask-assignee-autocomplete {
  flex: 1 1 220px;
  min-width: 180px;
}

.subtask-process-select {
  flex: 1 1 140px;
  min-width: 140px;
}

.subtask-add-btn {
  margin-top: 2px;
  min-width: 80px;
}

/* Tanlangan xodimlar */
.subtask-selected-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #444;
}

.subtask-member-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 160px;
  overflow-y: auto;
  padding-right: 4px;
}

.subtask-member-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 6px;
  background: #f8f9fa;
  transition: background 0.12s;
}

.subtask-member-item:hover {
  background: #f0f2f5;
}

.subtask-member-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.subtask-member-info {
  flex: 1;
  min-width: 0;
}

.subtask-member-name {
  font-weight: 500;
  font-size: 13.5px;
  display: block;
}

.subtask-member-process {
  font-size: 12px;
  color: #666;
  display: block;
}

.subtask-remove-btn {
  margin-left: auto;
}

.subtask-no-members {
  text-align: center;
  color: #888;
  font-size: 13px;
  padding: 16px 0;
  font-style: italic;
}

.st-form-act {
  position: absolute;
  left: 50%;
  top: -15px;
  transform: translateX(-50%) translateY(10px);
  opacity: 0;
  pointer-events: none;

  transition: 
    opacity 0.25s ease,
    transform 0.25s ease;
}

.st-form-act button {
  padding: 5px 10px;
  font-size: 10px;
  /* border-radius: 20%; */
}

.subtask-input {
  /* width: 70%; */
  padding: 4px;
  font-size: 13px;
  border: 1px solid var(--task-border-color);
  border-radius: 4px;
  /* background: var(--task-surface-alt-bg); */
  color: var(--task-text-main);
  transition: all 0.2s;
}

.subtask-input:focus {
  outline: none;
  border-color: var(--task-accent);
  box-shadow: 0 0 0 2px var(--task-accent-soft);
  background: var(--task-surface-bg);
}

.subtask-input::placeholder {
  color: var(--task-text-muted);
}

</style>
